export const getWord = (wid, language, insert) => {
  var wordProps = multipleWordsProps.find(props => props.wid === wid)
  var word = (wordProps === undefined || Boolean(wordProps[language]) === false) ? '' : wordProps[language]
  if (undefined !== insert) {
    Object.keys(insert).forEach(key => {
      word = word.replace(`{${key}}`, insert[key])
    })
  }
  return word
}

export const WID = {
  MENU_APP_BAR: {
    EVENT: 'MENU_APP_BAR/EVENT',
    LIVE: 'MENU_APP_BAR/LIVE',
    ONLINE_GAME: 'MENU_APP_BAR/ONLINE_GAME',
    PUZZLE: 'MENU_APP_BAR/PUZZLE',
    WEB_BOARD: 'MENU_APP_BAR/MENU_APP_BAR',
    SETTINGS: 'MENU_APP_BAR/SETTINGS',
    DONATE: 'MENU_APP_BAR/DONATE'
  },
  LEFT_MENU_BAR: {
    EVENT: 'LEFT_MENU_BAR/EVENT',
    LIVE: 'LEFT_MENU_BAR/LIVE',
    ONLINE_GAME: 'LEFT_MENU_BAR/ONLINE_GAME',
    PUZZLE: 'LEFT_MENU_BAR/PUZZLE',
    WEB_BOARD: 'LEFT_MENU_BAR/WEB_BOARD',
  },
  USER_MENU: {
    SCHEDULE_TWEET: 'USER_MENU/SCHEDULE_TWEET',
    SETTINGS: 'USER_MENU/SETTINGS',
    LOGOUT: 'USER_MENU/LOGOUT'
  },
  TWEET_LIST_DIALOG: {
    TITLE: 'TWEET_LIST_DIALOG/TITLE',
    SCHEDULE_POST_DATE: 'TWEET_LIST_DIALOG/SCHEDULE_POST_DATE',
    TEXT: 'TWEET_LIST_DIALOG/TEXT',
    IMAGE: 'TWEET_LIST_DIALOG/IMAGE',
    ACTION: 'TWEET_LIST_DIALOG/ACTION',
    DELETE_CONFIRM_DIALOG: {
      TITLE: 'TWEET_LIST_DIALOG/DELETE_CONFIRM_DIALOG/TITLE',
    }
  },
  EVENT_MENU: {
    HOME: 'EVENT_MENU/HOME',
    REGISTER: 'EVENT_MENU/REGISTER',
  },
  EVENT_LIST_CARD: {
    SHOW_DETAILS: 'EVENT_LIST_CARD/SHOW_DETAILS',
    CALENDAR: 'EVENT_LIST_CARD/CALENDAR',
    MONTH: 'EVENT_LIST_CARD/MONTH',
    DONT_FIND_EVENT_RECORD: 'EVENT_LIST_CARD/DONT_FIND_EVENT_RECORD',
  },
  EVENT_OVERVIEW: {
    MONTH: 'EVENT_OVERVIEW/MONTH',
    DAY: 'EVENT_OVERVIEW/DAY',
    PROVIDER: 'EVENT_OVERVIEW/PROVIDER',
    REVISION: 'EVENT_OVERVIEW/REVISION',
  },
  EVENT_CARD_MENU: {
    EDIT: 'EVENT_CARD_MENU/EDIT',
    DELETE: 'EVENT_CARD_MENU/DELETE',
    TWEET: 'EVENT_CARD_MENU/TWEET',
    VERSION_HISTORY: 'EVENT_CARD_MENU/VERSION_HISTORY',
    DELETE_CONFIRM_DIALOG: {
      TITLE: 'EVENT_CARD_MENU/DELETE_CONFIRM_DIALOG/TITLE',
      CONTENT: 'EVENT_CARD_MENU/DELETE_CONFIRM_DIALOG/CONTENT',
    }
  },
  EVENT_CARD: {
    ATTEND_OR_INTEREST_BUTTONS: {
      ATTEND: 'EVENT_CARD/ATTEND_OR_INTEREST_BUTTONS/ATTEND',
      INTEREST: 'EVENT_CARD/ATTEND_OR_INTEREST_BUTTONS/INTEREST'
    },
    EVENT_CONTENT: {
      CAUTION_MESSAGE: 'EVENT_CARD/EVENT_CONTENT/CAUTION_MESSAGE'
    },
    NOTIFY: {
      MESSAGE_FAILED_TO_DELETE_EVENT: 'EVENT_CARD/NOTIFY/MESSAGE_FAILED_TO_DELETE_EVENT',
    }
  },
  EVENT_TWEET_DIALOG: {
    DIALOG_TITLE: 'EVENT_TWEET_DIALOG/DIALOG_TITLE',
    TEXT: 'EVENT_TWEET_DIALOG/TEXT',
    REMAINING: 'EVENT_TWEET_DIALOG/REMAINING',
    IMMEDIATELY_POST: 'EVENT_TWEET_DIALOG/IMMEDIATELY_POST',
    DATETIME: 'EVENT_TWEET_DIALOG/DATETIME',
    ATTACHMENT_THUMBNAIL: 'EVENT_TWEET_DIALOG/ATTACHMENT_THUMBNAIL',
    SCHEDULE_TWEET_BUTTON: 'EVENT_TWEET_DIALOG/SCHEDULE_TWEET_BUTTON',
    TWEET_BUTTON: 'EVENT_TWEET_DIALOG/TWEET_BUTTON',
    DEFAULT_TEXT: {
      DATETIME: 'EVENT_TWEET_DIALOG/DEFAULT_TEXT/DATETIME',
      PLACE: 'EVENT_TWEET_DIALOG/DEFAULT_TEXT/PLACE',
    }
  },
  EVENT_REGISTER_CARD: {
    EDIT_TITLE: 'EVENT_REGISTER_CARD/EDIT_TITLE',
    REGISTER_TITLE: 'EVENT_REGISTER_CARD/REGISTER_TITLE',
    REGISTANT_TYPE_LABEL: 'EVENT_REGISTER_CARD/REGISTANT_TYPE_LABEL',
    ORGANIZER: 'EVENT_REGISTER_CARD/ORGANIZER',
    INFORMATION_PROVIDER: 'EVENT_REGISTER_CARD/INFORMATION_PROVIDER',
    THUMBNAIL_LABEL: 'EVENT_REGISTER_CARD/THUMBNAIL_LABEL',
    REGISTER_THUMBNAIL: 'EVENT_REGISTER_CARD/REGISTER_THUMBNAIL',
    DELETE_THUMBNAIL: 'EVENT_REGISTER_CARD/DELETE_THUMBNAIL',
    EVENT_NAME: 'EVENT_REGISTER_CARD/EVENT_NAME',
    START_DATE: 'EVENT_REGISTER_CARD/START_DATE',
    START_TIME: 'EVENT_REGISTER_CARD/START_TIME',
    ADD_END_DATETIME: 'EVENT_REGISTER_CARD/ADD_END_DATETIME',
    END_DATE: 'EVENT_REGISTER_CARD/END_DATE',
    END_TIME: 'EVENT_REGISTER_CARD/END_TIME',
    DELETE_END_DATETIME: 'EVENT_REGISTER_CARD/DELETE_END_DATETIME',
    PLACE_LABEL: 'EVENT_REGISTER_CARD/PLACE_LABEL',
    DETAIL_LABEL: 'EVENT_REGISTER_CARD/DETAIL_LABEL',
    UPDATE_BUTTON_LABEL: 'EVENT_REGISTER_CARD/UPDATE_BUTTON_LABEL',
    REGISTER_BUTTON_LABEL: 'EVENT_REGISTER_CARD/REGISTER_BUTTON_LABEL',
    ERROR_START_DATETIME1: 'EVENT_REGISTER_CARD/ERROR_START_DATETIME1',
    ERROR_START_DATETIME2: 'EVENT_REGISTER_CARD/ERROR_START_DATETIME2',
    ERROR_END_DATETIME1: 'EVENT_REGISTER_CARD/ERROR_END_DATETIME1',
    SNACKBAR_FAILED_RECEIVE: 'EVENT_REGISTER_CARD/SNACKBAR_FAILED_RECEIVE',
    SNACKBAR_FAILED_UPLOAD_THUMBNAIL: 'EVENT_REGISTER_CARD/SNACKBAR_FAILED_UPLOAD_THUMBNAIL',
    SNACKBAR_SUCCESS_REGISTER: 'EVENT_REGISTER_CARD/SNACKBAR_SUCCESS_REGISTER',
    SNACKBAR_FAILED_REGISTER: 'EVENT_REGISTER_CARD/SNACKBAR_FAILED_REGISTER',
    SNACKBAR_SUCCESS_UPDATE: 'EVENT_REGISTER_CARD/SNACKBAR_SUCCESS_UPDATE',
    SNACKBAR_FAILED_UPDATE: 'EVENT_REGISTER_CARD/SNACKBAR_FAILED_UPDATE',
  },
  EVENT_HISTORY_DIALOG: {
    DIALOG_TITLE: 'EVENT_HISTORY_DIALOG/DIALOG_TITLE',
    SHOW_BUTTON: 'EVENT_HISTORY_DIALOG/SHOW_BUTTON',
    REVISION: 'EVENT_HISTORY_DIALOG/REVISION',
    UPDATE_DATETIME: 'EVENT_HISTORY_DIALOG/UPDATE_DATETIME',
    CHANGES: 'EVENT_HISTORY_DIALOG/CHANGES',
    REGISTANT_TYPE: 'EVENT_HISTORY_DIALOG/REGISTANT_TYPE',
    THUMBNAIL: 'EVENT_HISTORY_DIALOG/THUMBNAIL',
    EVENT_NAME: 'EVENT_HISTORY_DIALOG/EVENT_NAME',
    ADDRESS: 'EVENT_HISTORY_DIALOG/ADDRESS',
    START_DATE: 'EVENT_HISTORY_DIALOG/START_DATE',
    START_TIME: 'EVENT_HISTORY_DIALOG/START_TIME',
    END_DATE: 'EVENT_HISTORY_DIALOG/END_DATE',
    END_TIME: 'EVENT_HISTORY_DIALOG/END_TIME',
    DETAIL: 'EVENT_HISTORY_DIALOG/DETAIL',
  },
  LIVE_LIST: {
    STATUS_MARK: {
      LIVE: 'LIVE_LIST/STATUS_MARK/LIVE',
      FINISH: 'LIVE_LIST/STATUS_MARK/FINISH'
    },
    SEARCH_PLACE_HOLDER: 'LIVE_LIST/SEARCH_PLACE_HOLDER',
    SEARCH_RESULT: {
      FIND: 'LIVE_LIST/SEARCH_RESULT/FIND',
      DONT_FIND: 'LIVE_LIST/SEARCH_RESULT/DONT_FIND',
    },
    FIXED_BUTTONS: {
      START_LIVE: 'LIVE_LIST/FIXED_BUTTONS/START_LIVE'
    }
  },
  LIVE_SETTINGS: {
    CARD_TITLE: 'LIVE_SETTINGS/CARD_TITLE',
    OPENINGS_LABEL: 'LIVE_SETTINGS/OPENINGS_LABEL',
    GAME_TITLE: 'LIVE_SETTINGS/GAME_TITLE',
    PLAYER_NAME_FIRST: 'LIVE_SETTINGS/PLAYER_NAME_FIRST',
    PLAYER_NAME_SECOND: 'LIVE_SETTINGS/PLAYER_NAME_SECOND',
    START: 'LIVE_SETTINGS/START',
  },
  LIVE_GAME: {
    CONTRIBUTOR_LABEL: 'LIVE_GAME/CONTRIBUTOR_LABEL',
    FIXED_BUTTONS: {
      SEND: 'LIVE_GAME/FIXED_BUTTONS/SEND',
      FINISH: 'LIVE_GAME/FIXED_BUTTONS/FINISH',
      DELETE: 'LIVE_GAME/FIXED_BUTTONS/DELETE',
      RESTART: 'LIVE_GAME/FIXED_BUTTONS/RESTART',
    },
    DELETE_CONFIRM_DIALOG: {
      DIALOG_TITLE: 'LIVE_GAME/DELETE_CONFIRM_DIALOG/DIALOG_TITLE'
    },
    TAB: {
      ANALYZE: 'LIVE_GAME/TAB/ANALYZE',
      ANALYSIS_BOARD: 'LIVE_GAME/TAB/ANALYSIS_BOARD',
    }
  },
  GAME_MENU: {
    HOME: 'GAME_MENU/HOME',
    SOUND_SETTINGS: 'GAME_MENU/HOME/SOUND_SETTINGS'
  },
  NEW_GAME_SETTINGS_CARD: {
    CARD_TITLE: 'NEW_GAME_SETTINGS_CARD/CARD_TITLE',
    GAME_TITLE_LABEL: 'NEW_GAME_SETTINGS_CARD/GAME_TITLE_LABEL',
    OPENING_RULE_LABEL: 'NEW_GAME_SETTINGS_CARD/OPENING_RULE_LABEL',
    GAME_TYPE: 'NEW_GAME_SETTINGS_CARD/GAME_TYPE',
    TIME: 'NEW_GAME_SETTINGS_CARD/TIME',
    TIME_INCREMENT: 'NEW_GAME_SETTINGS_CARD/TIME_INCREMENT',
    TIME_LIMITS_PER_MOVE: 'NEW_GAME_SETTINGS_CARD/TIME_LIMITS_PER_MOVE',
    MAKE_ROOM_BUTTON: 'NEW_GAME_SETTINGS_CARD/MAKE_ROOM_BUTTON',
    DAYS: 'NEW_GAME_SETTINGS_CARD/DAYS',
    MINUTE: 'NEW_GAME_SETTINGS_CARD/MINUTE',
    SECONDS: 'NEW_GAME_SETTINGS_CARD/SECONDS'
  },
  GAME_ROOM_LIST_CARD: {
    CARD_TITLE: 'GAME_ROOM_LIST_CARD/CARD_TITLE',
    OPENING_RULE: 'GAME_ROOM_LIST_CARD/OPENING_RULE',
    INCREMENT: 'GAME_ROOM_LIST_CARD/INCREMENT',
    TIME: 'GAME_ROOM_LIST_CARD/TIME',
    MINUTE: 'GAME_ROOM_LIST_CARD/MINUTE',
    SECONDS: 'GAME_ROOM_LIST_CARD/SECONDS',
  },
  GAME_INFO_CARD: {
    CARD_DRAW_BUTTONS_CONTENT: {
      ACCEPT_DRAW_GRID: {
        TITLE: 'GAME_INFO_CARD/CARD_DRAW_BUTTONS_CONTENT/ACCEPT_DRAW_GRID/TITLE',
        YES: 'GAME_INFO_CARD/CARD_DRAW_BUTTONS_CONTENT/ACCEPT_DRAW_GRID/YES',
        NO: 'GAME_INFO_CARD/CARD_DRAW_BUTTONS_CONTENT/ACCEPT_DRAW_GRID/NO',
      },
      OFFER_DRAW_GRID: {
        TITLE: 'GAME_INFO_CARD/CARD_DRAW_BUTTONS_CONTENT/OFFER_DRAW_GRID/TITLE',
        OFFERING: 'GAME_INFO_CARD/CARD_DRAW_BUTTONS_CONTENT/OFFER_DRAW_GRID/OFFERING',
        ACCEPT: 'GAME_INFO_CARD/CARD_DRAW_BUTTONS_CONTENT/OFFER_DRAW_GRID/ACCEPT',
        DENY: 'GAME_INFO_CARD/CARD_DRAW_BUTTONS_CONTENT/OFFER_DRAW_GRID/DENY',
      },
    },
    CARD_UNDO_BUTTONS_CONTENT: {
      ACCEPT_UNDO_GRID: {
        TITLE: 'GAME_INFO_CARD/CARD_UNDO_BUTTONS_CONTENT/ACCEPT_UNDO_GRID/TITLE',
        YES: 'GAME_INFO_CARD/CARD_UNDO_BUTTONS_CONTENT/ACCEPT_UNDO_GRID/YES',
        NO: 'GAME_INFO_CARD/CARD_UNDO_BUTTONS_CONTENT/ACCEPT_UNDO_GRID/NO',
      },
      OFFER_UNDO_GRID: {
        TITLE: 'GAME_INFO_CARD/CARD_UNDO_BUTTONS_CONTENT/OFFER_UNDO_GRID/TITLE',
        OFFERING: 'GAME_INFO_CARD/CARD_UNDO_BUTTONS_CONTENT/OFFER_UNDO_GRID/OFFERING',
        ACCEPT: 'GAME_INFO_CARD/CARD_UNDO_BUTTONS_CONTENT/OFFER_UNDO_GRID/ACCEPT',
        DENY: 'GAME_INFO_CARD/CARD_UNDO_BUTTONS_CONTENT/OFFER_UNDO_GRID/DENY',
      },
    },
    CARD_BUTTONS_CONTENT: {
      ENTER: 'GAME_INFO_CARD/CARD_BUTTONS_CONTENT/ENTER',
      LEAVE: 'GAME_INFO_CARD/CARD_BUTTONS_CONTENT/LEAVE',
      NEW: 'GAME_INFO_CARD/CARD_BUTTONS_CONTENT/NEW',
      REMATCH: 'GAME_INFO_CARD/CARD_BUTTONS_CONTENT/REMATCH',
      RESIGN: 'GAME_INFO_CARD/CARD_BUTTONS_CONTENT/RESIGN',
      DRAW: 'GAME_INFO_CARD/CARD_BUTTONS_CONTENT/DRAW',
      UNDO: 'GAME_INFO_CARD/CARD_BUTTONS_CONTENT/UNDO',
    },
    CARD_GAME_INFO_CONTENT: {
      TAB_BUTTONS: {
        CHAT: 'GAME_INFO_CARD/CARD_GAME_INFO_CONTENT/TAB_BUTTONS/CHAT',
        USERS: 'GAME_INFO_CARD/CARD_GAME_INFO_CONTENT/TAB_BUTTONS/USERS',
        INFORMATION: 'GAME_INFO_CARD/CARD_GAME_INFO_CONTENT/TAB_BUTTONS/INFORMATION',
        SETTINGS: 'GAME_INFO_CARD/CARD_GAME_INFO_CONTENT/TAB_BUTTONS/SETTINGS',
      }
    },
    CHAT_BOX: {
      MESSAGE_ENTERED_THE_ROOM: 'GAME_INFO_CARD/CHAT_BOX/MESSAGE_ENTERED_THE_ROOM',
      MESSAGE_LEFT_THE_ROOM: 'GAME_INFO_CARD/CHAT_BOX/MESSAGE_LEFT_THE_ROOM',
      GAME_START_CHIP: 'GAME_INFO_CARD/CHAT_BOX/GAME_START_CHIP',
      MESSAGE_VS: 'GAME_INFO_CARD/CHAT_BOX/MESSAGE_VS',
      GAME_FINISH_CHIP: 'GAME_INFO_CARD/CHAT_BOX/GAME_FINISH_CHIP',
      MESSAGE_MAKE_A_FIVE_IN_A_ROW: 'GAME_INFO_CARD/CHAT_BOX/MESSAGE_MAKE_A_FIVE_IN_A_ROW',
      MESSAGE_WAS_RESIGNED: 'GAME_INFO_CARD/CHAT_BOX/MESSAGE_WAS_RESIGNED',
      MESSAGE_ACCEPTED_THE_DRAW_PROPOSAL: 'GAME_INFO_CARD/CHAT_BOX/MESSAGE_ACCEPTED_THE_DRAW_PROPOSAL',
      MESSAGE_WAS_OUT_OF_TIME: 'GAME_INFO_CARD/CHAT_BOX/MESSAGE_WAS_OUT_OF_TIME',
      ENTER_A_MESSAGE: 'GAME_INFO_CARD/CHAT_BOX/ENTER_A_MESSAGE',
      GAME_RECORD_BUTTON: 'GAME_INFO_CARD/CHAT_BOX/GAME_RECORD_BUTTON',
      LOCK: 'GAME_INFO_CARD/CHAT_BOX/LOCK',
      UNLOCK: 'GAME_INFO_CARD/CHAT_BOX/UNLOCK',
    },
    GAME_INFO_BOX: {
      ROOM_LABEL: 'GAME_INFO_CARD/GAME_INFO_BOX/ROOM_LABEL',
      OPENING_RULE_LABEL: 'GAME_INFO_CARD/GAME_INFO_BOX/OPENING_RULE_LABEL',
      TIME: 'GAME_INFO_CARD/GAME_INFO_BOX/TIME',
      TIME_INCREMENTS: 'GAME_INFO_CARD/GAME_INFO_BOX/TIME_INCREMENTS',
      MINUTE: 'GAME_INFO_CARD/GAME_INFO_BOX/MINUTE',
      SECONDS: 'GAME_INFO_CARD/GAME_INFO_BOX/SECONDS',
    },
    SETTINGS_BOX: {
      PRIVATE_GAME: 'GAME_INFO_CARD/SETTINGS_BOX/PRIVATE_GAME'
    },
    RESIGN_CONFIRM_DIALOG: {
      TITLE: 'GAME_INFO_CARD/RESIGN_CONFIRM_DIALOG/TITLE',
    },
    DRAW_CONFIRM_DIALOG: {
      TITLE: 'GAME_INFO_CARD/DRAW_CONFIRM_DIALOG/TITLE',
    },
    UNDO_CONFIRM_DIALOG: {
      TITLE: 'GAME_INFO_CARD/UNDO_CONFIRM_DIALOG/UNDO_CONFIRM_DIALOG',
    },
    PRIVATE_GAME_KEY_DIALOG: {
      LABEL: 'GAME_INFO_CARD/PRIVATE_GAME_KEY_DIALOG/LABEL'
    }
  },
  POPUP_MESSAGE_CARD: {
    CARD_TITLE: 'POPUP_MESSAGE_CARD/CARD_TITLE',
    LIVE_GAME_SETTINGS_CARD: {
      TITLE_LABEL: 'POPUP_MESSAGE_CARD/LIVE_GAME_SETTINGS_CARD/TITLE_LABEL',
      OPENING_RULE_LABEL: 'POPUP_MESSAGE_CARD/LIVE_GAME_SETTINGS_CARD/OPENING_RULE_LABEL',
      TIME_LABEL: 'POPUP_MESSAGE_CARD/LIVE_GAME_SETTINGS_CARD/TIME_LABEL',
      TIME_INCREMENTS_LABEL: 'POPUP_MESSAGE_CARD/LIVE_GAME_SETTINGS_CARD/TIME_INCREMENTS_LABEL',
      UNDO_LABEL: 'POPUP_MESSAGE_CARD/LIVE_GAME_SETTINGS_CARD/UNDO_LABEL',
      TURN_LABEL: 'POPUP_MESSAGE_CARD/LIVE_GAME_SETTINGS_CARD/TURN_LABEL',
      MINUTE: 'POPUP_MESSAGE_CARD/LIVE_GAME_SETTINGS_CARD/MINUTE',
      SECONDS: 'POPUP_MESSAGE_CARD/LIVE_GAME_SETTINGS_CARD/SECONDS',
      UNDO: 'POPUP_MESSAGE_CARD/LIVE_GAME_SETTINGS_CARD/UNDO',
      TURN: 'POPUP_MESSAGE_CARD/LIVE_GAME_SETTINGS_CARD/TURN',
    }
  },
  LIVE_GAME_SETTINGS_CARD_ACTIONS: {
    ENTER_BUTTON: 'LIVE_GAME_SETTINGS_CARD_ACTIONS/ENTER_BUTTON',
    LEAVE_BUTTON: 'LIVE_GAME_SETTINGS_CARD_ACTIONS/LEAVE_BUTTON',
    COPLETE_SETTINGS_BUTTON: 'LIVE_GAME_SETTINGS_CARD_ACTIONS/COPLETE_SETTINGS_BUTTON',
    CHANGE_SETTINGS_BUTTON: 'LIVE_GAME_SETTINGS_CARD_ACTIONS/CHANGE_SETTINGS_BUTTON',
  },
  LIVE_GAME_END_CARD_ACTIONS: {
    ENTER_BUTTON: 'LIVE_GAME_END_CARD_ACTIONS/ENTER_BUTTON',
    LEAVE_BUTTON: 'LIVE_GAME_END_CARD_ACTIONS/LEAVE_BUTTON',
    NEW_GAME_BUTTON: 'LIVE_GAME_END_CARD_ACTIONS/NEW_GAME_BUTTON',
    REMATCH_BUTTON: 'LIVE_GAME_END_CARD_ACTIONS/REMATCH_BUTTON',
  },
  MAKE_LIVE_GAME_RESULT_STR: {
    MESSAGE_MAKE_A_FIVE_IN_A_ROW: 'MAKE_LIVE_GAME_RESULT_STR/MESSAGE_MAKE_A_FIVE_IN_A_ROW',
    MESSAGE_RESIGN: 'MAKE_LIVE_GAME_RESULT_STR/MESSAGE_RESIGN',
    MESSAGE_DRAW: 'MAKE_LIVE_GAME_RESULT_STR/MESSAGE_DRAW',
    MESSAGE_TIME_OUT: 'MAKE_LIVE_GAME_RESULT_STR/MESSAGE_TIME_OUT',
  },
  GAME_TYPE_MENU_ITEMS: {
    LIVE_GAME: 'GAME_TYPE_MENU_ITEMS/LIVE_GAME',
    DAILY_GAME: 'GAME_TYPE_MENU_ITEMS/DAILY_GAME'
  },
  OPENING_RULE_ITEMS: {
    FREE: 'OPENING_RULE_ITEMS/FREE',
    SOOSYRV8: 'OPENING_RULE_ITEMS/SOOSYRV8',
    PLAYER_FIRST_1: 'OPENING_RULE_ITEMS/PLAYER_FIRST_1',
    PLAYER_SECOND_1: 'OPENING_RULE_ITEMS/PLAYER_SECOND_1',
    PLAYER_FIRST_2: 'OPENING_RULE_ITEMS/PLAYER_FIRST_2',
    PLAYER_SECOND_2: 'OPENING_RULE_ITEMS/PLAYER_SECOND_2',
  },
  UNDO_ITEMS: {
    OK: 'UNDO_ITEMS/OK',
    NG: 'UNDO_ITEMS/NG'
  },
  TURN_ITEMS: {
    RANDOM: 'TURN_ITEMS/OK',
    FIRST: 'TURN_ITEMS/FIRST',
    SECOND: 'TURN_ITEMS/SECOND'
  },
  CHAT_MENU: {
    SEND_BOARD: 'CHAT_MENU/SEND_BOARD',
    USER_LIST: 'CHAT_MENU/USER_LIST',
    SHOW: 'CHAT_MENU/SHOW',
    HIDE: 'CHAT_MENU/HIDE'
  },
  CHAT_CARD: {
    CARD_TITLE: 'CHAT_CARD/CARD_TITLE',
    ANALYSIS_BOARD: 'CHAT_CARD/ANALYSIS_BOARD',
    ENTER_A_MESSAGE: 'CHAT_CARD/ENTER_A_MESSAGE',
    NOTIFY_OPEN_THE_ANALYSIS_BOARD: 'CHAT_CARD/NOTIFY_OPEN_THE_ANALYSIS_BOARD',
  },
  USER_LIST_DIALOG: {
    DIALOG_TITLE: 'USER_LIST_DIALOG/DIALOG_TITLE',
  },
  PUZZLE_MENU: {
    HOME: 'PUZZLE_MENU/HOME',
    REGISTER: 'PUZZLE_MENU/REGISTER',
  },
  PUZZLE_LIST_CARD: {
    SEARCH_PLACE_HOLDER: 'PUZZLE_LIST_CARD/SEARCH_PLACE_HOLDER',
    MESSAGE_FIND_TAG: 'PUZZLE_LIST_CARD/MESSAGE_FIND_TAG',
    MESSAGE_FIND_WORD: 'PUZZLE_LIST_CARD/MESSAGE_FIND_WORD',
    MESSAGE_DONT_FIND_WORD: 'PUZZLE_LIST_CARD/MESSAGE_DONT_FIND_WORD',
    TITLE_LABEL: 'PUZZLE_LIST_CARD/TITLE_LABEL',
    TURN_LABEL: 'PUZZLE_LIST_CARD/TURN_LABEL',
    PUZZLE_TYPE_LABEL: 'PUZZLE_LIST_CARD/PUZZLE_TYPE_LABEL',
    LEVEL_LABEL: 'PUZZLE_LIST_CARD/LEVEL_LABEL',
    RELEASE_DATE_LABEL: 'PUZZLE_LIST_CARD/RELEASE_DATE_LABEL',
    PUZZLE_TYPE_ITEMS: {
      VCT: 'VCT',
      VCF: 'VCF',
    },
    TURN_ITEMS: {
      BLACK_FIRST: 'BLACK_FIRST',
      WHITE_FIRST: 'WHITE_FIRST',
    },
  },
  PUZZLE_VIEWER: {
    FINISH_DELETE: 'PUZZLE_VIEWER/FINISH_DELETE',
    GO_TO_PUZZLE_LIST_BUTTON: 'PUZZLE_VIEWER/GO_TO_PUZZLE_LIST_BUTTON',
    RELEASE_DATE_LABEL: 'PUZZLE_VIEWER/RELEASE_DATE_LABEL',
    EDIT_BUTTON: 'PUZZLE_VIEWER/EDIT_BUTTON',
    DELETE_BUTTON: 'PUZZLE_VIEWER/DELETE_BUTTON',
    ANSWER_BUTTON: 'PUZZLE_VIEWER/ANSWER_BUTTON',
    AUTHORS_COMMENT: 'PUZZLE_VIEWER/AUTHORS_COMMENT',
    ENTER_A_COMMENT: 'PUZZLE_VIEWER/ENTER_A_COMMENT',
    ATTACHMENT_BOARD: 'PUZZLE_VIEWER/ATTACHMENT_BOARD',
    SEND_COMMENT_BUTTON: 'PUZZLE_VIEWER/SEND_COMMENT_BUTTON',
    RENJU_BOARD_BUTTON: 'PUZZLE_VIEWER/RENJU_BOARD_BUTTON',
    DELETE_COMMENT_BUTTON: 'PUZZLE_VIEWER/DELETE_COMMENT_BUTTON',
    MESSAGE_DONT_FOUND_PUZZLE: 'PUZZLE_VIEWER/MESSAGE_DONT_FOUND_PUZZLE',
    DELETE_CONFIRM_DIALOG: {
      DIALOG_TITLE: 'PUZZLE_VIEWER/DELETE_CONFIRM_DIALOG/DIALOG_TITLE',
    }
  },
  PUZZLE_REGISTER: {
    HORIZONTAL_LINEAR_STEPPER: {
      INFORMATION: 'PUZZLE_REGISTER/HORIZONTAL_LINEAR_STEPPER/INFORMATION',
      PUZZLE: 'PUZZLE_REGISTER/HORIZONTAL_LINEAR_STEPPER/PUZZLE',
      ANSWER: 'PUZZLE_REGISTER/HORIZONTAL_LINEAR_STEPPER/ANSWER',
      INPUTTED_CONTENT: 'PUZZLE_REGISTER/HORIZONTAL_LINEAR_STEPPER/INPUTTED_CONTENT'
    },
    STEPPER1: {
      TITLE_LABEL: 'PUZZLE_REGISTER/STEPPER1/TITLE_LABEL',
      PUZZLE_TYPE_LABEL: 'PUZZLE_REGISTER/STEPPER1/PUZZLE_TYPE_LABEL',
      TURN_TYPE_LABEL: 'PUZZLE_REGISTER/STEPPER1/TURN_TYPE_LABEL',
      LEVEL_LABEL: 'PUZZLE_REGISTER/STEPPER1/LEVEL_LABEL',
      OTHER_ANSWERS_LABEL: 'PUZZLE_REGISTER/STEPPER1/OTHER_ANSWERS_LABEL',
      COMMENT_LABEL: 'PUZZLE_REGISTER/STEPPER1/COMMENT_LABEL',
      RELEASE_DATE_LABEL: 'PUZZLE_REGISTER/STEPPER1/RELEASE_DATE_LABEL',
      SPECIFIED_RELEASE_DATE_LABEL: 'PUZZLE_REGISTER/STEPPER1/SPECIFIED_RELEASE_DATE_LABEL',
      TAG_LABEL: 'PUZZLE_REGISTER/STEPPER1/TAG_LABEL',
      ADD_TAG_BUTTON: 'PUZZLE_REGISTER/STEPPER1/ADD_TAG_BUTTON',
      CONTROL_BUTTONS: {
        BACK_BUTTON: 'PUZZLE_REGISTER/STEPPER1/CONTROL_BUTTONS/BACK_BUTTON',
        NEXT_BUTTON: 'PUZZLE_REGISTER/STEPPER1/CONTROL_BUTTONS/NEXT_BUTTON',
        UPDATE_BUTTON: 'PUZZLE_REGISTER/STEPPER1/CONTROL_BUTTONS/UPDATE_BUTTON',
        REGISTER_BUTTON: 'PUZZLE_REGISTER/STEPPER1/CONTROL_BUTTONS/REGISTER_BUTTON',
        DECIDE_BUTTON: 'PUZZLE_REGISTER/STEPPER1/CONTROL_BUTTONS/DECIDE_BUTTON',
      }
    },
    STEPPER4: {
      IMMEDIATELY_POST: 'PUZZLE_REGISTER/STEPPER4/IMMEDIATELY_POST',
      OTHER_ANSWERS_YES: 'PUZZLE_REGISTER/STEPPER4/OTHER_ANSWERS_YES',
      OTHER_ANSWERS_NO: 'PUZZLE_REGISTER/STEPPER4/OTHER_ANSWERS_NO',
      PUZZLE: 'PUZZLE_REGISTER/STEPPER4/PUZZLE',
      ANSWER: 'PUZZLE_REGISTER/STEPPER4/ANSWER',
    },
    MESSAGE_RESULT_SUCCESSFUL_UPDATE: 'PUZZLE_REGISTER/MESSAGE_RESULT_UPDATE_SUCCESSFUL',
    MESSAGE_RESULT_SUCCESSFUL_REGISTRATION: 'PUZZLE_REGISTER/MESSAGE_RESULT_REGISTRATION_SUCCESSFUL',
    MESSAGE_RESULT_FAILED_UPDATE: 'PUZZLE_REGISTER/MESSAGE_RESULT_FAILED_UPDATE',
    MESSAGE_RESULT_FAILED_REGISTRATION: 'PUZZLE_REGISTER/MESSAGE_RESULT_FAILED_UPDATE',
    NEXT_REGISTRATION_BUTTON: 'PUZZLE_REGISTER/NEXT_REGISTRATION_BUTTON',
    GO_TO_PUZZLE_LIST_BUTTON: 'PUZZLE_REGISTER/GO_TO_PUZZLE_LIST_BUTTON',
    DELETE_ANSWER_CONFIRM_DIALOG: {
      TITLE: 'PUZZLE_REGISTER/DELETE_ANSWER_CONFIRM_DIALOG/TITLE',
      CONTENT: 'PUZZLE_REGISTER/DELETE_ANSWER_CONFIRM_DIALOG/CONTENT',
    }
  },
  PUZZLE_TYPE_ITEMS: {
    VCT: 'PUZZLE_TYPE_ITEMS/VCT',
    VCF: 'PUZZLE_TYPE_ITEMS/VCF',
  },
  PUZZLE_LEVEL_ITEMS: {
    FOR_BEGINNER: 'PUZZLE_LEVEL_ITEMS/FOR_BEGINNER',
    FOR_LOW_KYU_PLAYER: 'PUZZLE_LEVEL_ITEMS/FOR_LOW_KYU_PLAYER',
    FOR_HIGH_KYU_PLAYER: 'PUZZLE_LEVEL_ITEMS/FOR_HIGH_KYU_PLAYER',
    FOR_LOW_DAN_PLAYER: 'PUZZLE_LEVEL_ITEMS/FOR_LOW_DAN_PLAYER',
    FOR_HIGH_DAN_PLAYER: 'PUZZLE_LEVEL_ITEMS/FOR_HIGH_DAN_PLAYER',
  },
  PUZZLE_TURN_ITEMS: {
    AUTO: 'PUZZLE_TURN_ITEMS/AUTO',
    BLACK: 'PUZZLE_TURN_ITEMS/BLACK',
    WHITE: 'PUZZLE_TURN_ITEMS/WHITE',
    CROSS: 'PUZZLE_TURN_ITEMS/CROSS',
    CIRCLE: 'PUZZLE_TURN_ITEMS/CIRCLE',
  },
  RENJU_BOARD_MENU: {
    NEW_BOARD: 'RENJU_BOARD_MENU/NEW_BOARD',
    SAVE: 'RENJU_BOARD_MENU/SAVE',
    SAVE_AS: 'RENJU_BOARD_MENU/SAVE_AS',
    RENAME: 'RENJU_BOARD_MENU/RENAME'
  },
  NEW_BOARD_CONFIRM_DIALOG: {
    TITLE: 'NEW_BOARD_CONFIRM_DIALOG/TITLE',
    CONTENT: 'NEW_BOARD_CONFIRM_DIALOG/CONTENT',
  },
  SAVE_CONFIRM_DIALOG: {
    TITLE: 'SAVE_CONFIRM_DIALOG/TITLE',
    TITLE_LABEL: 'SAVE_CONFIRM_DIALOG/TITLE_LABEL',
    LIMIT_HELPER_TEXT: 'SAVE_CONFIRM_DIALOG/LIMIT_HELPER_TEXT',
  },
  RENAME_CONFIRM_DIALOG: {
    TITLE: 'RENAME_CONFIRM_DIALOG/TITLE',
    TITLE_LABEL: 'RENAME_CONFIRM_DIALOG/TITLE_LABEL',
    LIMIT_HELPER_TEXT: 'SAVE_CONFIRM_DIALOG/LIMIT_HELPER_TEXT',
  },
  STORE_BOARD_CARD: {
    RECORD: {
      RECORD_MENU: {
        EDIT: 'STORE_BOARD_CARD/RECORD/RECORD_MENU/EDIT',
        DELETE: 'STORE_BOARD_CARD/RECORD/RECORD_MENU/DELETE',
        DELETE_CONFIRM_DIALOG: {
          TITLE: 'STORE_BOARD_CARD/RECORD/RECORD_MENU/DELETE_CONFIRM_DIALOG/TITLE'
        },
        EDIT_CONFIRM_DIALOG: {
          TITLE: 'STORE_BOARD_CARD/RECORD/RECORD_MENU/EDIT_CONFIRM_DIALOG/TITLE',
          CONTENT: 'STORE_BOARD_CARD/RECORD/RECORD_MENU/EDIT_CONFIRM_DIALOG/CONTENT',
        }
      }
    },
    TITLE: 'STORE_BOARD_CARD/TITLE',
    NO_FILES: 'STORE_BOARD_CARD/NO_FILES',
  },
  RENJU_BOARD_CARD: {
    ANALYZE_ACTION: {
      ANALYZE: 'RENJU_BOARD_CARD/ANALYZE_ACTION/ANALYZE',
    },
    MARK_ACTION: {
      MARK: 'RENJU_BOARD_CARD/MARK_ACTION/MARK'
    },
    SOOSYRV8: {
      MESSAGE_PUTS_ONE_OF_26_OPENINGS: 'RENJU_BOARD_CARD/SOOSYRV8/MESSAGE_PUTS_ONE_OF_26_OPENINGS',
      MESSAGE_SWAP: 'RENJU_BOARD_CARD/SOOSYRV8/MESSAGE_SWAP',
      MESSAGE_PUTS_THE_4TH_MOVE_AND_DECLARE_NUMBER_OF_FIFTH_MOVES: 'RENJU_BOARD_CARD/SOOSYRV8/MESSAGE_PUTS_THE_4TH_MOVE_AND_DECLARE_NUMBER_OF_FIFTH_MOVES',
      MESSAGE_NUMBER_OF_FIFTH_MOVES: 'RENJU_BOARD_CARD/SOOSYRV8/MESSAGE_NUMBER_OF_FIFTH_MOVES',
      MESSAGE_SELECT_FIFTH_MOVE_AND_PUT_SIXTH_MOVE: 'RENJU_BOARD_CARD/SOOSYRV8/MESSAGE_SELECT_FIFTH_MOVE_AND_PUT_SIXTH_MOVE',
      MESSAGE_YES: 'RENJU_BOARD_CARD/SOOSYRV8/MESSAGE_YES',
      MESSAGE_NO: 'RENJU_BOARD_CARD/SOOSYRV8/MESSAGE_NO',
      NAME: 'RENJU_BOARD_CARD/SOOSYRV8/NAME',
    },
    GAME_INFO: {
      GAME_RESULT: 'RENJU_BOARD_CARD/GAME_INFO/GAME_RESULT',
    },
    PUZZLE_INFO: {
      BLACK_TO_PLAY: 'RENJU_BOARD_CARD/PUZZLE_INFO/BLACK_TO_PLAY',
      WHITE_TO_PLAY: 'RENJU_BOARD_CARD/PUZZLE_INFO/WHITE_TO_PLAY'
    },
    TURN_SELECT_MENU: {
      TURN: 'RENJU_BOARD_CARD/TURN_SELECT_MENU/TURN'
    }
  },
  GAME_RESULT_ITEMS: {
    BLACK_PLAYER_RESIGN: 'GAME_RESULT_ITEMS/BLACK_PLAYER_RESIGN',
    WHITE_PLAYER_RESIGN: 'GAME_RESULT_ITEMS/WHITE_PLAYER_RESIGN',
    DRAW: 'GAME_RESULT_ITEMS/DRAW',
  },
  RENJU_BOARD_CARD_MENU: {
    CLOSE: 'RENJU_BOARD_CARD_MENU/CLOSE',
    OPEN_ANALYZE_TAB: 'RENJU_BOARD_CARD_MENU/OPEN_ANALYZE_TAB',
    BRANCH: 'RENJU_BOARD_CARD_MENU/BRANCH',
    MARK: 'RENJU_BOARD_CARD_MENU/MARK',
    SHARE: 'RENJU_BOARD_CARD_MENU/SHARE',
    TWEET: 'RENJU_BOARD_CARD_MENU/TWEET',
    DOWNLOAD_IMAGE: 'RENJU_BOARD_CARD_MENU/DOWNLOAD_IMAGE',
    GAME_INFO_SETTINGS: 'RENJU_BOARD_CARD_MENU/GAME_INFO_SETTINGS',
    PUZZLE_INFO_SETTINGS: 'RENJU_BOARD_CARD_MENU/PUZZLE_INFO_SETTINGS',
    SETTINGS: 'RENJU_BOARD_CARD_MENU/SETTINGS',
  },
  SHARE_DIALOG: {
    DIALOG_TITLE: 'SHARE_DIALOG/DIALOG_TITLE',
    SHORT_URL: 'SHARE_DIALOG/SHORT_URL',
    NOTIFY: {
      MESSAGE_SUCCESS_COPY_THE_SHORT_URL: 'SHARE_DIALOG/NOTIFY/MESSAGE_SUCCESS_COPY_THE_SHORT_URL',
      MESSAGE_FAILED_COPY_THE_SHORT_URL: 'SHARE_DIALOG/NOTIFY/MESSAGE_FAILED_COPY_THE_SHORT_URL',
    }
  },
  TWEET_DIALOG: {
    DIALOG_TITLE: 'TWEET_DIALOG/DIALOG_TITLE',
    TEXT_LABEL: 'TWEET_DIALOG/TEXT_LABEL',
    DATE_AND_TIME_LABEL: 'TWEET_DIALOG/DATE_AND_TIME_LABEL',
    SPECIFIED_DATE_AND_TIME_LABEL: 'TWEET_DIALOG/SPECIFIED_DATE_AND_TIME',
    ATTACHMENT_BOARD: 'TWEET_DIALOG/ATTACHMENT_BOARD',
    SCHEDULE_TWEET_BUTTON: 'TWEET_DIALOG/SCHEDULE_TWEET_BUTTON',
    TWEET_BUTTON: 'TWEET_DIALOG/TWEET_BUTTON',
    VS: 'TWEET_DIALOG/VS',
    LEVEL: 'TWEET_DIALOG/LEVEL'
  },
  DOWNLOAD_IMAGE_DIALOG: {
    DIALOG_TITLE: 'DOWNLOAD_IMAGE_DIALOG/DIALOG_TITLE',
    DOWNLOAD_BUTTON: 'DOWNLOAD_IMAGE_DIALOG/DOWNLOAD_BUTTON'
  },
  GAME_INFO_DIALOG: {
    DIALOG_TITLE: 'GAME_INFO_DIALOG/DIALOG_TITLE',
    OPENING_RULE_LABEL: 'GAME_INFO_DIALOG/OPENING_RULE_LABEL',
    TITLE_LABEL: 'GAME_INFO_DIALOG/TITLE_LABEL',
    PLAYER_NAME_LABEL: 'GAME_INFO_DIALOG/PLAYER_NAME_LABEL',
    NUMBER_OF_MOVES_AT_THE_END_OF_THE_GAME_LABEL: 'GAME_INFO_DIALOG/NUMBER_OF_MOVES_AT_THE_END_OF_THE_GAME_LABEL',
    GAME_RESULT: 'GAME_INFO_DIALOG/GAME_RESULT',
    BLACK: 'GAME_INFO_DIALOG/BLACK',
    WHITE: 'GAME_INFO_DIALOG/WHITE',
    NOTIFY_DIALOG: {
      DIALOG_TITLE: 'GAME_INFO_DIALOG/NOTIFY_DIALOG/DIALOG_TITLE',
      CONTENT: 'GAME_INFO_DIALOG/NOTIFY_DIALOG/CONTENT',
    }
  },
  SETTINGS_DIALOG: {
    DIALOG_TITLE: 'SETTINGS_DIALOG/DIALOG_TITLE',
    DISPLAY_SETTINGS: {
      SUBTITLE: 'SETTINGS_DIALOG/DISPLAY_SETTINGS/SUBTITLE',
      COORDINATE: 'SETTINGS_DIALOG/DISPLAY_SETTINGS/COORDINATE',
      NUMBER_OF_MOVE: 'SETTINGS_DIALOG/DISPLAY_SETTINGS/NUMBER_OF_MOVE',
      FORBIDDEN: 'SETTINGS_DIALOG/DISPLAY_SETTINGS/FORBIDDEN',
      NEXT_MOVE_MARK: 'SETTINGS_DIALOG/DISPLAY_SETTINGS/NEXT_MOVE_MARK',
      LAST_MOVE_MARK: 'SETTINGS_DIALOG/DISPLAY_SETTINGS/LAST_MOVE_MARK',
    },
    GAME_INFO_SETTINGS: {
      SUBTITLE: 'SETTINGS_DIALOG/GAME_INFO_SETTINGS/SUBTITLE',
      TITLE: 'SETTINGS_DIALOG/GAME_INFO_SETTINGS/TITLE',
      PLAYER_NAME: 'SETTINGS_DIALOG/GAME_INFO_SETTINGS/PLAYER_NAME',
      GAME_RESULT: 'SETTINGS_DIALOG/GAME_INFO_SETTINGS/GAME_RESULT',
    }
  },
  PUZZLE_INFO_DIALOG: {
    DIALOG_TITLE: 'PUZZLE_INFO_DIALOG/DIALOG_TITLE',
    TURN_LABEL: 'PUZZLE_INFO_DIALOG/TURN_LABEL',
    PUZZLE_TYPE_LABEL: 'PUZZLE_INFO_DIALOG/PUZZLE_TYPE_LABEL',
    LEVEL_LABEL: 'PUZZLE_INFO_DIALOG/LEVEL_LABEL',
  },
  CONTROL_CARD: {
    SOOSYRV8_SWAP_BOX: {
      MESSAGE_DO_YOU_SWAP: 'CONTROL_CARD/SOOSYRV8_SWAP_BOX/MESSAGE_DO_YOU_SWAP',
      YES_BUTTON: 'CONTROL_CARD/SOOSYRV8_SWAP_BOX/YES_BUTTON',
      NO_BUTTON: 'CONTROL_CARD/SOOSYRV8_SWAP_BOX/NO_BUTTON',
    },
    SOOSYRV8_FIVE_MOVE_NUMBER_BOX: {
      MESSAGE_DECLARE_NUMBER_OF_FIFTH_MOVES: 'CONTROL_CARD/SOOSYRV8_FIVE_MOVE_NUMBER_BOX/MESSAGE_DECLARE_NUMBER_OF_FIFTH_MOVES',
      OK_BUTTON: 'CONTROL_CARD/SOOSYRV8_FIVE_MOVE_NUMBER_BOX/OK_BUTTON',
    },
    SOOSYRV8_FIVE_MOVES_BOX: {
      MESSAGE_IS_IT_OK: 'CONTROL_CARD/SOOSYRV8_FIVE_MOVES_BOX/MESSAGE_IS_IT_OK',
      OK_BUTTON: 'CONTROL_CARD/SOOSYRV8_FIVE_MOVES_BOX/OK_BUTTON'
    }
  },
  EDIT_MODE_MENU: {
    PUZZLE_CONFIRM_DIALOG: {
      TITLE: 'EDIT_MODE_MENU/PUZZLE_CONFIRM_DIALOG/TITLE',
      CONTENT: 'EDIT_MODE_MENU/PUZZLE_CONFIRM_DIALOG/CONTENT'
    },
    NORMAL_CONFIRM_DIALOG: {
      TITLE: 'EDIT_MODE_MENU/NORMAL_CONFIRM_DIALOG/TITLE',
      CONTENT: 'EDIT_MODE_MENU/PUZZLE_CONFIRM_DIALOG/CONTENT'
    }
  },
  SETTINGS_MENU_ITEMS: {
    USER_INFORMATION: 'SETTINGS_MENU_ITEMS/USER_INFORMATION',
    RENJU_BOARD: 'SETTINGS_MENU_ITEMS/RENJU_BOARD',
    PAYMENT: 'SETTINGS_MENU_ITEMS/PAYMENT',
    DONATION: 'SETTINGS_MENU_ITEMS/DONATION'
  },
  ACCOUNT_SETTINGS_CARD: {
    TITLE: 'ACCOUNT_SETTINGS_CARD/TITLE',
    AVATAR_LABEL: 'ACCOUNT_SETTINGS_CARD/AVATAR_LABEL',
    CHANGE_BUTTON: 'ACCOUNT_SETTINGS_CARD/CHANGE_BUTTON',
    HEADER_LABEL: 'ACCOUNT_SETTINGS_CARD/HEADER_LABEL',
    USER_NAME_LABEL: 'ACCOUNT_SETTINGS_CARD/USER_NAME_LABEL',
    DISPLAY_NAME_LABEL: 'ACCOUNT_SETTINGS_CARD/DISPLAY_NAME_LABEL',
    RANK_LABEL: 'ACCOUNT_SETTINGS_CARD/RANK_LABEL',
    COUNTRY_LABEL: 'ACCOUNT_SETTINGS_CARD/COUNTRY_LABEL',
    CITY_LABEL: 'ACCOUNT_SETTINGS_CARD/CITY_LABEL',
    BIRTHDAY_LABEL: 'ACCOUNT_SETTINGS_CARD/BIRTHDAY_LABEL',
    SELF_INTRODUCTION_LABEL: 'ACCOUNT_SETTINGS_CARD/SELF_INTRODUCTION_LABEL',
    SAVE_BUTTON: 'ACCOUNT_SETTINGS_CARD/SAVE_BUTTON',
    ERROR_MESSAGE_NAME_IS_ALREADY_BEING_USED: 'ACCOUNT_SETTINGS_CARD/ERROR_MESSAGE_NAME_IS_ALREADY_BEING_USED',
    SUCCESS: 'ACCOUNT_SETTINGS_CARD/SUCCESS',
    FAILED: 'ACCOUNT_SETTINGS_CARD/FAILED',
    NOTIFY_UPDATE_FAILED: 'ACCOUNT_SETTINGS_CARD/NOTIFY_UPDATE_FAILED',
    NOTIFY_UPDATE_COMPLETE: 'ACCOUNT_SETTINGS_CARD/NOTIFY_UPDATE_COMPLETE',
  },
  RANK_ITEMS: {
    DAN: 'RANK_ITEMS/DAN',
    KYU: 'RANK_ITEMS/KYU',
  },
  RENJU_BOARD_SETTINGS_CARD: {
    TITLE: 'RENJU_BOARD_SETTINGS_CARD/TITLE',
    NUMBER_OF_MOVE: 'RENJU_BOARD_SETTINGS_CARD/NUMBER_OF_MOVE',
    FORBIDDEN_MOVE_MARK: 'RENJU_BOARD_SETTINGS_CARD/FORBIDDEN_MOVE_MARK',
    NEXT_MOVE_MARK: 'RENJU_BOARD_SETTINGS_CARD/NEXT_MOVE_MARK',
    LAST_MOVE_MARK: 'RENJU_BOARD_SETTINGS_CARD/LAST_MOVE_MARK',
  },
  USER_TAB_ITEMS: {
    PROFILE: 'USER_TAB_ITEMS/PROFILE',
    EVENT: 'USER_TAB_ITEMS/EVENT',
    PUZZLE: 'USER_TAB_ITEMS/PUZZLE',
  },
  PROFILE_PAGE: {
    SELF_INTRODUCTION: 'PROFILE_PAGE/SELF_INTRODUCTION',
    RANK_LABEL: 'PROFILE_PAGE/RANK_LABEL',
    COUNTRY_LABEL: 'PROFILE_PAGE/COUNTRY_LABEL',
    CITY_LABEL: 'PROFILE_PAGE/CITY_LABEL',
    BIRTHDAY_LABEL: 'PROFILE_PAGE/BIRTHDAY_LABEL',
    JOINED: 'PROFILE_PAGE/JOINED',
  },
  EVENT_TAB: {
    OWNER: 'EVENT_TAB/OWNER',
    ATTEND: 'EVENT_TAB/ATTEND',
    INTEREST: 'EVENT_TAB/INTEREST',
  },
  LOGIN: {
    BACK_BUTTON: 'LOGIN/BACK_BUTTON',
    TERMS_OF_SERVICE_BUTTON: 'LOGIN/TERMS_OF_SERVICE',
  },
  LOGIN_CARD: {
    CARD_TITLE: 'LOGIN_CARD/CARD_TITLE',
    CONTENT: 'LOGIN_CARD/CONTENT',
  },
  SIGN_UP: {
    LOGOUT_AND_USE_BUTTON: 'SIGN_UP/LOGOUT_AND_USE_BUTTON'
  },
  SIGN_UP_CARD: {
    CARD_TITLE: 'SIGN_UP_CARD/CARD_TITLE',
    CONTENT: 'SIGN_UP_CARD/CONTENT',
    USER_NAME_LABEL: 'SIGN_UP_CARD/USER_NAME_LABEL',
    DISPLAY_NAME_LABEL: 'SIGN_UP_CARD/DISPLAY_NAME_LABEL',
    REGISTER_BUTTON: 'SIGN_UP_CARD/REGISTER_BUTTON',
    NOTIFY: {
      MESSAGE_NAME_IS_ALREADY_BEING_USED: 'SIGN_UP_CARD/NOTIFY/MESSAGE_NAME_IS_ALREADY_BEING_USED'
    }
  },
  COMMENT: {
    ENTER_A_COMMENT: 'COMMENT/ENTER_A_COMMENT',
    COMMENT_BUTTON: 'COMMENT/COMMENT_BUTTON',
    DELETE_BUTTON: 'COMMENT/DELETE_BUTTON',
    MESSAGE_NOT_ALLOWED: 'COMMENT/MESSAGE_NOT_ALLOWED',
  },
  PAYMENT_CARD: {
    CARD_TITLE: 'PAYMENT_CARD/CARD_TITLE',
    PAYER: 'PAYMENT_CARD/PAYER'
  },
  PAYPAL_CARD: {
    PAYMENT_TYPE: 'PAYPAL_CARD/PAYMENT_TYPE',
    AMOUNT: 'PAYPAL_CARD/AMOUNT',
    GIVE_MONTHLY: 'PAYPAL_CARD/GIVE_MONTHLY',
    JUST_ONCE: 'PAYPAL_CARD/JUST_ONCE',
    OTHER: 'PAYPAL_CARD/OTHER',
  },
  DONATION_SETTINGS_CARD: {
    CARD_HEADER: 'DONATION_SETTINGS_CARD/CARD_HEADER',
    VISIBLE_DONOR: 'DONATION_SETTINGS_CARD/VISIBLE_DONOR'
  },
  SOUND_SETTINGS_DIALOG: {
    ENTER: 'SOUND_SETTINGS_DIALOG/ENTER',
    PUT_PIECE: 'SOUND_SETTINGS_DIALOG/PUT_PIECE',
    SWAP: 'SOUND_SETTINGS_DIALOG/SWAP',
  },
  REQUEST_PASSWORD_DIALOG: {
    LABEL: 'REQUEST_PASSWORD_DIALOG/LABEL'
  }
}

export const multipleWordsProps = [
  // MENU_APP_BAR
  { wid: WID.MENU_APP_BAR.EVENT,
    en: 'Event',
    ja: 'イベント',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.MENU_APP_BAR.LIVE,
    en: 'Live',
    ja: '対局中継',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.MENU_APP_BAR.ONLINE_GAME,
    en: 'Online Game',
    ja: 'オンライン対戦',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.MENU_APP_BAR.PUZZLE,
    en: 'Puzzle',
    ja: '詰め連珠',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.MENU_APP_BAR.WEB_BOARD,
    en: 'Renju Board',
    ja: '連珠盤',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.MENU_APP_BAR.SETTINGS,
    en: 'Settings',
    ja: '設定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.MENU_APP_BAR.DONATE,
    en: 'Donate',
    ja: '寄付',
    cn: '',
    tw: '',
    ko: '',
  },

  // LEFT_MENU_BAR
  { wid: WID.LEFT_MENU_BAR.EVENT,
    en: 'Event',
    ja: 'イベント',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LEFT_MENU_BAR.LIVE,
    en: 'Live',
    ja: '対局中継',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LEFT_MENU_BAR.ONLINE_GAME,
    en: 'Online Game',
    ja: 'オンライン対戦',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LEFT_MENU_BAR.PUZZLE,
    en: 'Puzzle',
    ja: '詰め連珠',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LEFT_MENU_BAR.WEB_BOARD,
    en: 'Renju Board',
    ja: '連珠盤',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.USER_MENU.SCHEDULE_TWEET,
    en: 'Schedule Tweet',
    ja: '予約ツイート',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.USER_MENU.SETTINGS,
    en: 'Settings',
    ja: '設定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.USER_MENU.LOGOUT,
    en: 'Logout',
    ja: 'ログアウト',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_LIST_DIALOG.TITLE,
    en: '',
    ja: '予約ツイート一覧',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_LIST_DIALOG.SCHEDULE_POST_DATE,
    en: '',
    ja: '予約投稿日時',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_LIST_DIALOG.TEXT,
    en: 'Text',
    ja: 'テキスト',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_LIST_DIALOG.IMAGE,
    en: 'Photo',
    ja: '画像',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_LIST_DIALOG.ACTION,
    en: 'Action',
    ja: 'アクション',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_LIST_DIALOG.DELETE_CONFIRM_DIALOG.TITLE,
    en: '',
    ja: '削除しますか？',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_MENU.HOME,
    en: 'Home',
    ja: 'ホーム',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_MENU.REGISTER,
    en: 'Register',
    ja: '登録',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_LIST_CARD.SHOW_DETAILS,
    en: 'Show Details',
    ja: '詳細を見る',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_LIST_CARD.CALENDAR,
    en: 'Calendar',
    ja: 'カレンダー',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_LIST_CARD.MONTH,
    en: '',
    ja: '月',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_LIST_CARD.DONT_FIND_EVENT_RECORD,
    en: '',
    ja: '該当するイベントはありませんでした。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_OVERVIEW.MONTH,
    en: '',
    ja: '月',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_OVERVIEW.DAY,
    en: '',
    ja: '日',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_OVERVIEW.PROVIDER,
    en: '',
    ja: '情報提供者',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_OVERVIEW.REVISION,
    en: 'Revision',
    ja: 'リビジョン',
    cn: '',
    tw: '',
    ko: '',
  },

  // EVENT_CARD_MENU
  { wid: WID.EVENT_CARD_MENU.EDIT,
    en: 'Edit',
    ja: '編集',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_CARD_MENU.DELETE,
    en: 'Delete',
    ja: '削除',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_CARD_MENU.TWEET,
    en: 'Tweet',
    ja: 'ツイート',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_CARD_MENU.VERSION_HISTORY,
    en: 'Version History',
    ja: '更新履歴',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_CARD_MENU.DELETE_CONFIRM_DIALOG.TITLE,
    en: '',
    ja: '注意',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_CARD_MENU.DELETE_CONFIRM_DIALOG.CONTENT,
    en: '',
    ja: 'このイベントを削除しますか。',
    cn: '',
    tw: '',
    ko: '',
  },

  // EVENT_CARD
  { wid: WID.EVENT_CARD.ATTEND_OR_INTEREST_BUTTONS.ATTEND,
    en: 'Attend',
    ja: '参加予定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_CARD.ATTEND_OR_INTEREST_BUTTONS.INTEREST,
    en: 'Interest',
    ja: '興味あり',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_CARD.EVENT_CONTENT.CAUTION_MESSAGE,
    en: '',
    ja: '主催者ではないユーザーから提供されたイベント情報です。内容に不備がある場合はメニューにある[編集]から訂正できます（ユーザーログインが必要）。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_CARD.NOTIFY.MESSAGE_FAILED_TO_DELETE_EVENT,
    en: 'Failed to delete event',
    ja: 'イベントの削除に失敗しました。',
    cn: '',
    tw: '',
    ko: '',
  },

  // EVENT_TWEET_DIALOG
  { wid: WID.EVENT_TWEET_DIALOG.DIALOG_TITLE,
    en: 'Tweet',
    ja: 'ツイート',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_TWEET_DIALOG.TEXT,
    en: 'Text',
    ja: 'テキスト',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_TWEET_DIALOG.REMAINING,
    en: 'Remaining',
    ja: '残り文字数',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_TWEET_DIALOG.IMMEDIATELY_POST,
    en: 'Immediately post',
    ja: '即時投稿',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_TWEET_DIALOG.DATETIME,
    en: 'Date and time',
    ja: 'ツイート日時',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_TWEET_DIALOG.ATTACHMENT_THUMBNAIL,
    en: 'Attachment thumbnail',
    ja: 'サムネイル添付',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_TWEET_DIALOG.SCHEDULE_TWEET_BUTTON,
    en: 'Schedule Tweet',
    ja: '予約ツイート',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_TWEET_DIALOG.TWEET_BUTTON,
    en: 'Tweet',
    ja: 'ツイート',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_TWEET_DIALOG.DEFAULT_TEXT.DATETIME,
    en: 'Date and time',
    ja: '日時',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_TWEET_DIALOG.DEFAULT_TEXT.PLACE,
    en: 'Place',
    ja: '場所',
    cn: '',
    tw: '',
    ko: '',
  },

  // EVENT_REGISTER_CARD
  { wid: WID.EVENT_REGISTER_CARD.EDIT_TITLE,
    en: 'Edit Event',
    ja: 'イベント編集',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.REGISTER_TITLE,
    en: 'Register Event',
    ja: 'イベント登録',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.REGISTANT_TYPE_LABEL,
    en: 'Registant Type',
    ja: '登録者種別',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.ORGANIZER,
    en: 'Organizer',
    ja: '主催者',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.INFORMATION_PROVIDER,
    en: 'Information Provider',
    ja: '情報提供者',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.THUMBNAIL_LABEL,
    en: 'Thumbnail',
    ja: 'サムネイル',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.REGISTER_THUMBNAIL,
    en: 'Register',
    ja: '登録',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.DELETE_THUMBNAIL,
    en: 'Delete',
    ja: '削除',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.EVENT_NAME,
    en: 'Event Name',
    ja: 'イベント名',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.START_DATE,
    en: 'Start Date',
    ja: '開始日',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.START_TIME,
    en: 'Start Time',
    ja: '開始時間',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.ADD_END_DATETIME,
    en: 'Add End DateTime',
    ja: '終了日時',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.END_DATE,
    en: 'End Date',
    ja: '終了日',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.END_TIME,
    en: 'End Time',
    ja: '終了時間',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.DETAIL_LABEL,
    en: 'Detail',
    ja: '詳細',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.DELETE_END_DATETIME,
    en: 'Delete',
    ja: '削除',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.PLACE_LABEL,
    en: 'Place',
    ja: '場所 (サジェストから選択してください)',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.UPDATE_BUTTON_LABEL,
    en: 'Update',
    ja: '更新',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.REGISTER_BUTTON_LABEL,
    en: 'Register',
    ja: '登録',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.ERROR_START_DATETIME1,
    en: '',
    ja: '現在の時刻よりも後の時刻を設定してください。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.ERROR_START_DATETIME2,
    en: '',
    ja: '1年以上先の開始時刻は設定できません。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.ERROR_END_DATETIME1,
    en: '',
    ja: '開始時刻よりも後の時刻を設定してください。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.SNACKBAR_FAILED_RECEIVE,
    en: '',
    ja: 'イベントの取得に失敗しました。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.SNACKBAR_FAILED_UPLOAD_THUMBNAIL,
    en: '',
    ja: 'サムネイルのアップロードに失敗しました。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.SNACKBAR_SUCCESS_REGISTER,
    en: '',
    ja: 'イベント登録が完了しました。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.SNACKBAR_FAILED_REGISTER,
    en: '',
    ja: 'イベント登録に失敗しました。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.SNACKBAR_SUCCESS_UPDATE,
    en: '',
    ja: 'イベント更新が完了しました。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_REGISTER_CARD.SNACKBAR_FAILED_UPDATE,
    en: '',
    ja: 'イベント更新に失敗しました。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.DIALOG_TITLE,
    en: 'History',
    ja: '履歴',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.SHOW_BUTTON,
    en: 'Show',
    ja: '表示',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.REVISION,
    en: 'Revision',
    ja: 'リビジョン',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.UPDATE_DATETIME,
    en: 'Updated',
    ja: '更新日時',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.CHANGES,
    en: 'Changes',
    ja: '変更箇所',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.REGISTANT_TYPE,
    en: 'RegistantType',
    ja: '登録者種別',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.THUMBNAIL,
    en: 'Thumbnail',
    ja: 'サムネイル',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.EVENT_NAME,
    en: 'EventName',
    ja: 'イベント名',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.ADDRESS,
    en: 'Address',
    ja: '住所',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.START_DATE,
    en: 'StartDate',
    ja: '開始日',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.START_TIME,
    en: 'StartTime',
    ja: '開始時間',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.END_DATE,
    en: 'EndDate',
    ja: '終了日',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.END_TIME,
    en: 'EndTime',
    ja: '終了時間',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_HISTORY_DIALOG.DETAIL,
    en: 'Detail',
    ja: '詳細',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_LIST.STATUS_MARK.LIVE,
    en: 'LIVE',
    ja: 'LIVE',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_LIST.STATUS_MARK.FINISH,
    en: 'FINISH',
    ja: '終了',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_LIST.SEARCH_PLACE_HOLDER,
    en: 'Search',
    ja: '検索',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_LIST.SEARCH_RESULT.FIND,
    en: '',
    ja: '「{search}」に一致した対局は {totalRows} 件ありました。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_LIST.SEARCH_RESULT.DONT_FIND,
    en: '',
    ja: '「{search}」に一致する対局はありませんでした。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_LIST.FIXED_BUTTONS.START_LIVE,
    en: 'Start Live',
    ja: '中継開始',
    cn: '',
    tw: '',
    ko: '',
  },

  // LIVE_SETTINGS
  { wid: WID.LIVE_SETTINGS.CARD_TITLE,
    en: 'Live Settings',
    ja: '中継設定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_SETTINGS.OPENINGS_LABEL,
    en: 'Opening Rule',
    ja: '開局規定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_SETTINGS.GAME_TITLE,
    en: 'Title',
    ja: 'タイトル',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_SETTINGS.PLAYER_NAME_FIRST,
    en: 'Player Name (First)',
    ja: '対局者名(先手)',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_SETTINGS.PLAYER_NAME_SECOND,
    en: 'Player Name (Second)',
    ja: '対局者名(後手)',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_SETTINGS.START,
    en: 'Start',
    ja: '開始',
    cn: '',
    tw: '',
    ko: '',
  },

  // LIVE_GAME
  { wid: WID.LIVE_GAME.CONTRIBUTOR_LABEL,
    en: 'Contributor',
    ja: '中継者',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_GAME.FIXED_BUTTONS.SEND,
    en: 'Send',
    ja: '送信',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_GAME.FIXED_BUTTONS.FINISH,
    en: 'Finish',
    ja: '中継終了',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_GAME.FIXED_BUTTONS.DELETE,
    en: 'Delete',
    ja: '削除',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_GAME.FIXED_BUTTONS.RESTART,
    en: 'Restart',
    ja: '再開',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_GAME.DELETE_CONFIRM_DIALOG.DIALOG_TITLE,
    en: '',
    ja: '削除しますか？',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_GAME.TAB.ANALYSIS_BOARD,
    en: 'Analysis board',
    ja: '検討図',
    cn: '',
    tw: '',
    ko: '',
  },

  // GAME_MENU
  { wid: WID.GAME_MENU.HOME,
    en: 'Home',
    ja: 'ホーム',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_MENU.SOUND_SETTINGS,
    en: 'Sound Settings',
    ja: '効果音設定',
    cn: '',
    tw: '',
    ko: '',
  },

  // NEW_GAME_SETTINGS_CARD
  { wid: WID.NEW_GAME_SETTINGS_CARD.CARD_TITLE,
    en: 'New Game',
    ja: '新しいゲーム',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.NEW_GAME_SETTINGS_CARD.GAME_TITLE_LABEL,
    en: 'Title',
    ja: 'タイトル',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.NEW_GAME_SETTINGS_CARD.OPENING_RULE_LABEL,
    en: 'Opening rule',
    ja: '開局規定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.NEW_GAME_SETTINGS_CARD.GAME_TYPE,
    en: 'Type',
    ja: '種別',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.NEW_GAME_SETTINGS_CARD.TIME,
    en: 'Time',
    ja: '持ち時間',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.NEW_GAME_SETTINGS_CARD.TIME_INCREMENT,
    en: 'Time increments',
    ja: '増加秒数',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.NEW_GAME_SETTINGS_CARD.TIME_LIMITS_PER_MOVE,
    en: 'Time limits per move',
    ja: '一手当たりの持ち時間',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.NEW_GAME_SETTINGS_CARD.MAKE_ROOM_BUTTON,
    en: 'Make room',
    ja: '部屋を作成',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.NEW_GAME_SETTINGS_CARD.DAYS,
    en: 'days',
    ja: '日',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.NEW_GAME_SETTINGS_CARD.MINUTE,
    en: 'minute',
    ja: '分',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.NEW_GAME_SETTINGS_CARD.SECONDS,
    en: 'seconds',
    ja: '秒',
    cn: '',
    tw: '',
    ko: '',
  },

  // GAME_ROOM_LIST_CARD
  { wid: WID.GAME_ROOM_LIST_CARD.CARD_TITLE,
    en: 'Rooms List',
    ja: '部屋一覧',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_ROOM_LIST_CARD.OPENING_RULE,
    en: 'Opening Rule',
    ja: '開局規定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_ROOM_LIST_CARD.INCREMENT,
    en: 'Increment',
    ja: '増加',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_ROOM_LIST_CARD.TIME,
    en: 'Time',
    ja: '持ち時間',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_ROOM_LIST_CARD.MINUTE,
    en: 'minute',
    ja: '分',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_ROOM_LIST_CARD.SECONDS,
    en: 'seconds',
    ja: '秒',
    cn: '',
    tw: '',
    ko: '',
  },

  // GAME_INFO_CARD
  { wid: WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.ACCEPT_DRAW_GRID.TITLE,
    en: 'Offer A Draw / Do you accept ?',
    ja: '引き分け提案 / 受け入れますか？',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.ACCEPT_DRAW_GRID.YES,
    en: 'Yes',
    ja: 'はい',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.ACCEPT_DRAW_GRID.NO,
    en: 'No',
    ja: 'いいえ',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.OFFER_DRAW_GRID.TITLE,
    en: 'Offer A Draw',
    ja: '引き分け提案',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.OFFER_DRAW_GRID.OFFERING,
    en: 'Offering',
    ja: '提案中',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.OFFER_DRAW_GRID.ACCEPT,
    en: 'Accept',
    ja: '承諾',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_DRAW_BUTTONS_CONTENT.OFFER_DRAW_GRID.DENY,
    en: 'Deny',
    ja: '拒否',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_UNDO_BUTTONS_CONTENT.ACCEPT_UNDO_GRID.TITLE,
    en: 'Offer Undo / Do you accept ?',
    ja: '待った提案 / 受け入れますか？',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_UNDO_BUTTONS_CONTENT.ACCEPT_UNDO_GRID.YES,
    en: 'Yes',
    ja: 'はい',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_UNDO_BUTTONS_CONTENT.ACCEPT_UNDO_GRID.NO,
    en: 'No',
    ja: 'いいえ',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_UNDO_BUTTONS_CONTENT.OFFER_UNDO_GRID.TITLE,
    en: 'Offer Undo',
    ja: '待った提案',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_UNDO_BUTTONS_CONTENT.OFFER_UNDO_GRID.OFFERING,
    en: 'Offering',
    ja: '提案中',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_UNDO_BUTTONS_CONTENT.OFFER_UNDO_GRID.ACCEPT,
    en: 'Accept',
    ja: '承諾',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_UNDO_BUTTONS_CONTENT.OFFER_UNDO_GRID.DENY,
    en: 'Deny',
    ja: '拒否',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.ENTER,
    en: 'Enter',
    ja: '参加',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.LEAVE,
    en: 'Leave',
    ja: '退席',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.NEW,
    en: 'New Game',
    ja: '新規',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.REMATCH,
    en: 'Rematch',
    ja: '再戦',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.RESIGN,
    en: 'Resign',
    ja: '投了',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.DRAW,
    en: 'Draw',
    ja: '引き分け',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_BUTTONS_CONTENT.UNDO,
    en: 'Undo',
    ja: '待った',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_GAME_INFO_CONTENT.TAB_BUTTONS.CHAT,
    en: 'Chat',
    ja: 'チャット',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_GAME_INFO_CONTENT.TAB_BUTTONS.USERS,
    en: 'Users',
    ja: 'ユーザー',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_GAME_INFO_CONTENT.TAB_BUTTONS.INFORMATION,
    en: 'Information',
    ja: '情報',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CARD_GAME_INFO_CONTENT.TAB_BUTTONS.SETTINGS,
    en: 'Settings',
    ja: '設定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_ENTERED_THE_ROOM,
    en: 'enterd the room.',
    ja: 'が部屋に入りました',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_LEFT_THE_ROOM,
    en: 'left the room.',
    ja: 'が部屋からでました',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CHAT_BOX.GAME_START_CHIP,
    en: 'Start',
    ja: 'ゲーム開始',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_VS,
    en: 'VS',
    ja: '対',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CHAT_BOX.GAME_FINISH_CHIP,
    en: 'End',
    ja: 'ゲーム終了',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_MAKE_A_FIVE_IN_A_ROW,
    en: 'make a five in a row.',
    ja: 'の五連',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_WAS_RESIGNED,
    en: 'resigned.',
    ja: 'が投了しました',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_ACCEPTED_THE_DRAW_PROPOSAL,
    en: 'accepted the draw proposal.',
    ja: 'が引き分けを受け入れました',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CHAT_BOX.MESSAGE_WAS_OUT_OF_TIME,
    en: 'was out of time.',
    ja: 'の時間切れ',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CHAT_BOX.ENTER_A_MESSAGE,
    en: 'Enter a message...',
    ja: 'メッセージを入力...',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CHAT_BOX.GAME_RECORD_BUTTON,
    en: 'Record',
    ja: '棋譜',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CHAT_BOX.LOCK,
    en: 'lock',
    ja: 'が部屋に鍵をかけました。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.CHAT_BOX.UNLOCK,
    en: 'unlock',
    ja: 'が部屋の鍵を解除しました。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.GAME_INFO_BOX.ROOM_LABEL,
    en: 'Room',
    ja: 'ルーム',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.GAME_INFO_BOX.OPENING_RULE_LABEL,
    en: 'Opening rule',
    ja: '開局規定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.GAME_INFO_BOX.TIME,
    en: 'Time',
    ja: '持ち時間',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.GAME_INFO_BOX.TIME_INCREMENTS,
    en: 'Time increments',
    ja: '増加時間',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.GAME_INFO_BOX.MINUTES,
    en: 'minute',
    ja: '分',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.GAME_INFO_BOX.SECONDS,
    en: 'seconds',
    ja: '秒',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.SETTINGS_BOX.PRIVATE_GAME,
    en: 'Private game',
    ja: 'プライベート対局',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.RESIGN_CONFIRM_DIALOG.TITLE,
    en: 'Do you resign ?',
    ja: '投了しますか？',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.DRAW_CONFIRM_DIALOG.TITLE,
    en: 'Do you offer a draw ?',
    ja: '引き分けを提案しますか？',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.UNDO_CONFIRM_DIALOG.TITLE,
    en: 'Undo',
    ja: '待った提案',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_CARD.PRIVATE_GAME_KEY_DIALOG.LABEL,
    en: 'password',
    ja: 'パスワード',
    cn: '',
    tw: '',
    ko: '',
  },

  // POPUP_MESSAGE_CARD
  { wid: WID.POPUP_MESSAGE_CARD.CARD_TITLE,
    en: 'Live Game',
    ja: 'ライブゲーム',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TITLE_LABEL,
    en: 'Title',
    ja: 'タイトル',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.OPENING_RULE_LABEL,
    en: 'Opening rule',
    ja: '開局規定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TIME_LABEL,
    en: 'Time',
    ja: '持ち時間',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TIME_INCREMENTS_LABEL,
    en: 'Increment',
    ja: '増加時間',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.UNDO_LABEL,
    en: 'Undo',
    ja: '待った',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TURN_LABEL,
    en: 'Turn',
    ja: '手番',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.MINUTE,
    en: 'min',
    ja: '分',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.SECONDS,
    en: 'sec',
    ja: '秒',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.UNDO,
    en: 'Undo',
    ja: '待った',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.POPUP_MESSAGE_CARD.LIVE_GAME_SETTINGS_CARD.TURN,
    en: 'Turn',
    ja: '手番',
    cn: '',
    tw: '',
    ko: '',
  },



  // LIVE_GAME_SETTINGS_CARD_ACTIONS
  { wid: WID.LIVE_GAME_SETTINGS_CARD_ACTIONS.ENTER_BUTTON,
    en: 'Enter',
    ja: '参加',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_GAME_SETTINGS_CARD_ACTIONS.LEAVE_BUTTON,
    en: 'Leave',
    ja: '退席',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_GAME_SETTINGS_CARD_ACTIONS.COPLETE_SETTINGS_BUTTON,
    en: 'OK',
    ja: '設定完了',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_GAME_SETTINGS_CARD_ACTIONS.CHANGE_SETTINGS_BUTTON,
    en: 'Change',
    ja: '設定変更',
    cn: '',
    tw: '',
    ko: '',
  },

  // LIVE_GAME_END_CARD_ACTIONS
  { wid: WID.LIVE_GAME_END_CARD_ACTIONS.ENTER_BUTTON,
    en: 'Enter',
    ja: '参加',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_GAME_END_CARD_ACTIONS.LEAVE_BUTTON,
    en: 'Leave',
    ja: '退席',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_GAME_END_CARD_ACTIONS.NEW_GAME_BUTTON,
    en: 'New Game',
    ja: '新規',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LIVE_GAME_END_CARD_ACTIONS.REMATCH_BUTTON,
    en: 'Rematch',
    ja: '再戦',
    cn: '',
    tw: '',
    ko: '',
  },

  // MAKE_LIVE_GAME_RESULT_STR
  { wid: WID.MAKE_LIVE_GAME_RESULT_STR.MESSAGE_MAKE_A_FIVE_IN_A_ROW,
    en: '{winner} win by making a five in a row.',
    ja: '五連により{winner}の勝ち',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.MAKE_LIVE_GAME_RESULT_STR.MESSAGE_RESIGN,
    en: '{winner} win by {loser}\'s resignation.',
    ja: '{loser}の投了により{winner}の勝ち',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.MAKE_LIVE_GAME_RESULT_STR.MESSAGE_DRAW,
    en: 'Draw by {player}\'s proposal',
    ja: '{player}の提案により引き分け',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.MAKE_LIVE_GAME_RESULT_STR.MESSAGE_TIME_OUT,
    en: '{winner} win by {loser}\'s time out',
    ja: '{loser}の時間切れにより{winner}の勝ち',
    cn: '',
    tw: '',
    ko: '',
  },

  // GAME_TYPE_MENU_ITEMS
  { wid: WID.GAME_TYPE_MENU_ITEMS.LIVE_GAME,
    en: 'Live Game',
    ja: 'ライブ',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_TYPE_MENU_ITEMS.DAILY_GAME,
    en: 'Daily Game',
    ja: 'デイリー',
    cn: '',
    tw: '',
    ko: '',
  },

  // OPENING_RULE_ITEMS
  { wid: WID.OPENING_RULE_ITEMS.FREE,
    en: 'Free',
    ja: '自由打ち',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.OPENING_RULE_ITEMS.SOOSYRV8,
    en: 'Soosyrv8',
    ja: 'ソーソロフ8',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.OPENING_RULE_ITEMS.PLAYER_FIRST_1,
    en: 'First',
    ja: '先手',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.OPENING_RULE_ITEMS.PLAYER_SECOND_1,
    en: 'Second',
    ja: '後手',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.OPENING_RULE_ITEMS.PLAYER_FIRST_2,
    en: 'First',
    ja: '仮先',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.OPENING_RULE_ITEMS.PLAYER_SECOND_2,
    en: 'Second',
    ja: '仮後',
    cn: '',
    tw: '',
    ko: '',
  },

  // UNDO_ITEMS
  { wid: WID.UNDO_ITEMS.OK,
    en: 'OK',
    ja: 'あり',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.UNDO_ITEMS.NG,
    en: 'NG',
    ja: 'なし',
    cn: '',
    tw: '',
    ko: '',
  },

  // TURN_ITEMS
  { wid: WID.TURN_ITEMS.RANDOM,
    en: 'Random',
    ja: 'ランダム',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TURN_ITEMS.FIRST,
    en: 'First',
    ja: 'あなたが先手',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TURN_ITEMS.SECOND,
    en: 'Second',
    ja: 'あなたが後手',
    cn: '',
    tw: '',
    ko: '',
  },

  // CHAT_MENU
  { wid: WID.CHAT_MENU.SEND_BOARD,
    en: 'Send board',
    ja: '盤面を送信',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.CHAT_MENU.USER_LIST,
    en: 'User list',
    ja: 'ユーザー一覧',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.CHAT_MENU.SHOW,
    en: 'Show',
    ja: '表示',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.CHAT_MENU.HIDE,
    en: 'Hide',
    ja: '非表示',
    cn: '',
    tw: '',
    ko: '',
  },

  // CHAT_CARD
  { wid: WID.CHAT_CARD.CARD_TITLE,
    en: 'Chat',
    ja: 'チャット',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.CHAT_CARD.ANALYSIS_BOARD,
    en: 'Analysis Board',
    ja: '検討図',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.CHAT_CARD.ENTER_A_MESSAGE,
    en: 'Enter a message...',
    ja: 'メッセージを入力...',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.CHAT_CARD.NOTIFY_OPEN_THE_ANALYSIS_BOARD,
    en: 'Open the analysis board',
    ja: '検討図を開きました。',
    cn: '',
    tw: '',
    ko: '',
  },

  // USER_LIST_DIALOG
  { wid: WID.USER_LIST_DIALOG.DIALOG_TITLE,
    en: 'User list',
    ja: 'ユーザー一覧',
    cn: '',
    tw: '',
    ko: '',
  },

  // PUZZLE_MENU
  { wid: WID.PUZZLE_MENU.HOME,
    en: 'Home',
    ja: 'ホーム',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_MENU.REGISTER,
    en: 'Register',
    ja: '登録',
    cn: '',
    tw: '',
    ko: '',
  },

  // PUZZLE_LIST_CARD
  { wid: WID.PUZZLE_LIST_CARD.SEARCH_PLACE_HOLDER,
    en: 'Search',
    ja: '検索',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LIST_CARD.MESSAGE_FIND_TAG,
    en: '{totalRows} results',
    ja: '{totalRows} 件',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LIST_CARD.MESSAGE_FIND_WORD,
    en: '',
    ja: '「{word}」に一致した詰め連珠は {totalRows} 件ありました。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LIST_CARD.MESSAGE_DONT_FIND_WORD,
    en: '',
    ja: '「{word}」に一致した詰め連珠はありませんでした。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LIST_CARD.TITLE_LABEL,
    en: 'Title',
    ja: 'タイトル',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LIST_CARD.TURN_LABEL,
    en: 'Turn',
    ja: '手番',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LIST_CARD.PUZZLE_TYPE_LABEL,
    en: 'Puzzle type',
    ja: '問題種別',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LIST_CARD.LEVEL_LABEL,
    en: 'Level',
    ja: '難易度',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LIST_CARD.RELEASE_DATE_LABEL,
    en: 'Release date',
    ja: '公開日時',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LIST_CARD.PUZZLE_TYPE_ITEMS.VCT,
    en: 'VCT',
    ja: '追い詰め',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LIST_CARD.PUZZLE_TYPE_ITEMS.VCF,
    en: 'VCF',
    ja: '四追い',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LIST_CARD.TURN_ITEMS.BLACK_FIRST,
    en: 'Black',
    ja: '黒先',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LIST_CARD.TURN_ITEMS.WHITE_FIRST,
    en: 'White',
    ja: '白先',
    cn: '',
    tw: '',
    ko: '',
  },

  // PUZZLE_VIEWER
  { wid: WID.PUZZLE_VIEWER.FINISH_DELETE,
    en: 'The Puzzle has been deleted.',
    ja: '削除完了',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_VIEWER.GO_TO_PUZZLE_LIST_BUTTON,
    en: 'Go to puzzle list.',
    ja: '詰め連珠一覧へ',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_VIEWER.RELEASE_DATE_LABEL,
    en: 'Release date',
    ja: '公開日時',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_VIEWER.EDIT_BUTTON,
    en: 'Edit',
    ja: '編集',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_VIEWER.DELETE_BUTTON,
    en: 'Delete',
    ja: '削除',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_VIEWER.ANSWER_BUTTON,
    en: 'Answer',
    ja: '答え',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_VIEWER.AUTHORS_COMMENT,
    en: 'Author\'s comment',
    ja: '作者コメント',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_VIEWER.ENTER_A_COMMENT,
    en: 'Enter a comment...',
    ja: 'コメントを入力...',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_VIEWER.ATTACHMENT_BOARD,
    en: 'Attachment board',
    ja: '盤面を添付',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_VIEWER.SEND_COMMENT_BUTTON,
    en: 'Comment',
    ja: 'コメント',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_VIEWER.RENJU_BOARD_BUTTON,
    en: 'Renju Board',
    ja: '連珠盤',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_VIEWER.DELETE_COMMENT_BUTTON,
    en: 'Delete',
    ja: '削除',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_VIEWER.MESSAGE_DONT_FOUND_PUZZLE,
    en: '',
    ja: '該当する詰め連珠は見つかりませんでした。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_VIEWER.DELETE_CONFIRM_DIALOG.DIALOG_TITLE,
    en: '',
    ja: '削除しますか？',
    cn: '',
    tw: '',
    ko: '',
  },

  // PUZZLE_REGISTER
  { wid: WID.PUZZLE_REGISTER.HORIZONTAL_LINEAR_STEPPER.INFORMATION,
    en: 'Information',
    ja: '情報',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.HORIZONTAL_LINEAR_STEPPER.PUZZLE,
    en: 'Puzzle',
    ja: '問題',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.HORIZONTAL_LINEAR_STEPPER.ANSWER,
    en: 'Answer',
    ja: '答え',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.HORIZONTAL_LINEAR_STEPPER.INPUTTED_CONTENT,
    en: 'Inputted content',
    ja: '入力内容',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.TITLE_LABEL,
    en: 'Title',
    ja: 'タイトル',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.PUZZLE_TYPE_LABEL,
    en: 'Puzzle type',
    ja: '問題の種別',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.TURN_TYPE_LABEL,
    en: 'Turn',
    ja: '手番',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.LEVEL_LABEL,
    en: 'Level',
    ja: '難易度',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.OTHER_ANSWERS_LABEL,
    en: 'Other answers',
    ja: '余詰め',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.COMMENT_LABEL,
    en: 'Comment',
    ja: 'コメント',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.RELEASE_DATE_LABEL,
    en: 'Release date',
    ja: '公開日時',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.SPECIFIED_RELEASE_DATE_LABEL,
    en: 'Specified',
    ja: '公開日時指定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.TAG_LABEL,
    en: 'Tag',
    ja: 'タグ',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.ADD_TAG_BUTTON,
    en: 'Add',
    ja: '追加',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.CONTROL_BUTTONS.BACK_BUTTON,
    en: 'Back',
    ja: '戻る',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.CONTROL_BUTTONS.NEXT_BUTTON,
    en: 'Forward',
    ja: '次へ',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.CONTROL_BUTTONS.UPDATE_BUTTON,
    en: 'Update',
    ja: '更新',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.CONTROL_BUTTONS.REGISTER_BUTTON,
    en: 'Register',
    ja: '登録',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER1.CONTROL_BUTTONS.DECIDE_BUTTON,
    en: 'Decide',
    ja: '決定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER4.IMMEDIATELY_POST,
    en: 'Immediately post',
    ja: '即時投稿',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER4.OTHER_ANSWERS_YES,
    en: 'YES',
    ja: 'あり',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER4.OTHER_ANSWERS_NO,
    en: 'NO',
    ja: 'なし',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER4.PUZZLE,
    en: 'Puzzle',
    ja: '問題',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.STEPPER4.ANSWER,
    en: 'Answer',
    ja: '答え',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.MESSAGE_RESULT_SUCCESSFUL_UPDATE,
    en: 'Successful update.',
    ja: '更新成功',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.MESSAGE_RESULT_SUCCESSFUL_REGISTRATION,
    en: 'Successful registration.',
    ja: '登録成功',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.MESSAGE_RESULT_FAILED_UPDATE,
    en: 'failed update.',
    ja: '更新失敗',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.MESSAGE_RESULT_FAILED_REGISTRATION,
    en: 'failed registration.',
    ja: '登録失敗',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.NEXT_REGISTRATION_BUTTON,
    en: 'Next registration',
    ja: '次の問題を登録',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.GO_TO_PUZZLE_LIST_BUTTON,
    en: 'Go to puzzle list',
    ja: '詰め連珠一覧へ',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.DELETE_ANSWER_CONFIRM_DIALOG.TITLE,
    en: '',
    ja: '注意',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_REGISTER.DELETE_ANSWER_CONFIRM_DIALOG.CONTENT,
    en: '',
    ja: '答えの情報は削除されますがよろしいでしょうか？',
    cn: '',
    tw: '',
    ko: '',
  },
  
  // PUZZLE_TYPE_ITEMS
  { wid: WID.PUZZLE_TYPE_ITEMS.VCT,
    en: 'VCT',
    ja: '追い詰め',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_TYPE_ITEMS.VCF,
    en: 'VCF',
    ja: '四追い',
    cn: '',
    tw: '',
    ko: '',
  },

  // PUZZLE_LEVEL_ITEMS
  { wid: WID.PUZZLE_LEVEL_ITEMS.FOR_BEGINNER,
    en: 'For beginner',
    ja: '初心者向け',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LEVEL_ITEMS.FOR_LOW_KYU_PLAYER,
    en: 'For low kyu player (10kyu - 4kyu)',
    ja: '級位者向け(10級～4級)',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LEVEL_ITEMS.FOR_HIGH_KYU_PLAYER,
    en: 'For high kyu player (3kyu - 1kyu)',
    ja: '級位者向け(3級～1級)',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LEVEL_ITEMS.FOR_LOW_DAN_PLAYER,
    en: 'For low dan player',
    ja: '低段者向け',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_LEVEL_ITEMS.FOR_HIGH_DAN_PLAYER,
    en: 'For high dan player',
    ja: '高段者向け',
    cn: '',
    tw: '',
    ko: '',
  },

  // PUZZLE_TURN_ITEMS
  { wid: WID.PUZZLE_TURN_ITEMS.AUTO,
    en: 'AUTO',
    ja: 'AUTO',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_TURN_ITEMS.BLACK,
    en: 'Black to play',
    ja: '黒先',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_TURN_ITEMS.WHITE,
    en: 'White to play',
    ja: '白先',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_TURN_ITEMS.CROSS,
    en: 'Cross to play',
    ja: 'X 先',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_TURN_ITEMS.CIRCLE,
    en: 'Circle to play',
    ja: 'O 先',
    cn: '',
    tw: '',
    ko: '',
  },

  // RENJU_BOARD_MENU
  { wid: WID.RENJU_BOARD_MENU.NEW_BOARD,
    en: 'New Board',
    ja: '新しいボード',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_MENU.SAVE,
    en: 'Save',
    ja: '上書き保存',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_MENU.SAVE_AS,
    en: 'Save as',
    ja: '名前を付けて保存',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_MENU.RENAME,
    en: 'Rename',
    ja: '名前変更',
    cn: '',
    tw: '',
    ko: '',
  },

  // NEW_BOARD_CONFIRM_DIALOG
  { wid: WID.NEW_BOARD_CONFIRM_DIALOG.TITLE,
    en: '',
    ja: '注意',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.NEW_BOARD_CONFIRM_DIALOG.CONTENT,
    en: '',
    ja: '入力した情報は全て削除されます。',
    cn: '',
    tw: '',
    ko: '',
  },

  // SAVE_CONFIRM_DIALOG
  { wid: WID.SAVE_CONFIRM_DIALOG.TITLE,
    en: 'Save',
    ja: '名前を付けて保存',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SAVE_CONFIRM_DIALOG.TITLE_LABEL,
    en: 'Title',
    ja: 'タイトル',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SAVE_CONFIRM_DIALOG.LIMIT_HELPER_TEXT,
    en: '20 characters or less',
    ja: '20文字まで',
    cn: '',
    tw: '',
    ko: '',
  },

  // RENAME_CONFIRM_DIALOG
  { wid: WID.RENAME_CONFIRM_DIALOG.TITLE,
    en: 'Rename',
    ja: '名前変更',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENAME_CONFIRM_DIALOG.TITLE_LABEL,
    en: 'Title',
    ja: 'タイトル',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENAME_CONFIRM_DIALOG.LIMIT_HELPER_TEXT,
    en: '20 characters or less',
    ja: '20文字まで',
    cn: '',
    tw: '',
    ko: '',
  },

  // STORE_BOARD_CARD
  { wid: WID.STORE_BOARD_CARD.RECORD.RECORD_MENU.EDIT,
    en: 'Edit',
    ja: '編集',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.STORE_BOARD_CARD.RECORD.RECORD_MENU.DELETE,
    en: 'Delete',
    ja: '削除',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.STORE_BOARD_CARD.RECORD.RECORD_MENU.DELETE_CONFIRM_DIALOG.TITLE,
    en: 'Are you sure to want to delete?',
    ja: '削除しますか？',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.STORE_BOARD_CARD.RECORD.RECORD_MENU.EDIT_CONFIRM_DIALOG.TITLE,
    en: 'Notice',
    ja: '注意',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.STORE_BOARD_CARD.RECORD.RECORD_MENU.EDIT_CONFIRM_DIALOG.CONTENT,
    en: 'The editing renju board is not saved.\nDo you want to open without saving.',
    ja: '現在編集中の局面は保存されていません。\n保存せずに開きますか？',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.STORE_BOARD_CARD.TITLE,
    en: 'Files',
    ja: 'ファイル',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.STORE_BOARD_CARD.NO_FILES,
    en: 'No files',
    ja: 'ファイルはありません。',
    cn: '',
    tw: '',
    ko: '',
  },

  // RENJU_BOARD_CARD
  { wid: WID.RENJU_BOARD_CARD.ANALYZE_ACTION.ANALYZE,
    en: 'Analyze',
    ja: '分岐',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD.MARK_ACTION.MARK,
    en: 'Mark',
    ja: '記号',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_PUTS_ONE_OF_26_OPENINGS,
    en: 'Puts one of 26 openings',
    ja: '珠型提示',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_SWAP,
    en: 'Swap',
    ja: '交換(スワップ)',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_PUTS_THE_4TH_MOVE_AND_DECLARE_NUMBER_OF_FIFTH_MOVES,
    en: 'Puts the 4th move and declare number of fifth moves',
    ja: '4手目と5手目の題数を提示',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_NUMBER_OF_FIFTH_MOVES,
    en: 'Number of fifth moves',
    ja: '5手目の題数',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_SELECT_FIFTH_MOVE_AND_PUT_SIXTH_MOVE,
    en: 'Select fifth move and put sixth move',
    ja: '5手目を選択し6手目を打つ',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_YES,
    en: 'Yes',
    ja: 'する',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD.SOOSYRV8.MESSAGE_NO,
    en: 'No',
    ja: 'しない',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD.SOOSYRV8.NAME,
    en: 'Soosyrv8',
    ja: 'ソーソロフ８',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD.GAME_INFO.GAME_RESULT,
    en: '{number} : {result}',
    ja: '{number} にて{result}',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD.PUZZLE_INFO.BLACK_TO_PLAY,
    en: 'Black to play',
    ja: '黒先',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD.PUZZLE_INFO.WHITE_TO_PLAY,
    en: 'White to play',
    ja: '白先',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD.TURN_SELECT_MENU.TURN,
    en: 'Turn',
    ja: '手番',
    cn: '',
    tw: '',
    ko: '',
  },


  // GAME_RESULT_ITEMS
  { wid: WID.GAME_RESULT_ITEMS.BLACK_PLAYER_RESIGN,
    en: 'Black player resign',
    ja: '黒投了',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_RESULT_ITEMS.WHITE_PLAYER_RESIGN,
    en: 'White player resign',
    ja: '白投了',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_RESULT_ITEMS.DRAW,
    en: 'Draw',
    ja: '満局',
    cn: '',
    tw: '',
    ko: '',
  },

  // RENJU_BOARD_CARD_MENU
  { wid: WID.RENJU_BOARD_CARD_MENU.CLOSE,
    en: 'Close',
    ja: '閉じる',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD_MENU.OPEN_ANALYZE_TAB,
    en: 'Open analyze tab',
    ja: '検討タブを開く',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD_MENU.BRANCH,
    en: 'Branch',
    ja: '分岐',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD_MENU.MARK,
    en: 'Mark',
    ja: '記号',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD_MENU.SHARE,
    en: 'Share',
    ja: 'シェア',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD_MENU.TWEET,
    en: 'Tweet',
    ja: 'ツイート',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD_MENU.DOWNLOAD_IMAGE,
    en: 'Download image',
    ja: '画像ダウンロード',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD_MENU.GAME_INFO_SETTINGS,
    en: 'Game information settings',
    ja: '対局情報設定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD_MENU.PUZZLE_INFO_SETTINGS,
    en: 'Puzzle information settings',
    ja: '詰め連珠情報設定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_CARD_MENU.SETTINGS,
    en: 'Settings',
    ja: '設定',
    cn: '',
    tw: '',
    ko: '',
  },

  // SHARE_DIALOG
  { wid: WID.SHARE_DIALOG.DIALOG_TITLE,
    en: 'Share',
    ja: 'シェア',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SHARE_DIALOG.SHORT_URL,
    en: 'ShortURL',
    ja: 'ショートURL',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SHARE_DIALOG.NOTIFY.MESSAGE_SUCCESS_COPY_THE_SHORT_URL,
    en: 'Copied the short URL to clipboard.',
    ja: 'クリップボードにショートURLをコピーしました。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SHARE_DIALOG.NOTIFY.MESSAGE_FAILED_COPY_THE_SHORT_URL,
    en: 'Failed to copy the short URL to clipboard.',
    ja: 'クリップボードへのショートURLのコピーが失敗しました。',
    cn: '',
    tw: '',
    ko: '',
  },

  // TWEET_DIALOG
  { wid: WID.TWEET_DIALOG.DIALOG_TITLE,
    en: 'Tweet',
    ja: 'ツイート',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_DIALOG.TEXT_LABEL,
    en: 'Text',
    ja: 'テキスト',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_DIALOG.DATE_AND_TIME_LABEL,
    en: 'Date and time',
    ja: '投稿日時',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_DIALOG.SPECIFIED_DATE_AND_TIME_LABEL,
    en: 'Specified date & time',
    ja: '日時指定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_DIALOG.ATTACHMENT_BOARD,
    en: 'Attachment board',
    ja: '棋譜画像',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_DIALOG.SCHEDULE_TWEET_BUTTON,
    en: 'Schedule Tweet',
    ja: '予約ツイート',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_DIALOG.TWEET_BUTTON,
    en: 'Tweet',
    ja: 'ツイート',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_DIALOG.VS,
    en: 'VS',
    ja: '対',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.TWEET_DIALOG.LEVEL,
    en: 'Level',
    ja: '難易度',
    cn: '',
    tw: '',
    ko: '',
  },

  // DOWNLOAD_IMAGE_DIALOG
  { wid: WID.DOWNLOAD_IMAGE_DIALOG.DIALOG_TITLE,
    en: 'Download image',
    ja: '画像ダウンロード',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.DOWNLOAD_IMAGE_DIALOG.DOWNLOAD_BUTTON,
    en: 'Download',
    ja: 'ダウンロード',
    cn: '',
    tw: '',
    ko: '',
  },

  // GAME_INFO_DIALOG
  { wid: WID.GAME_INFO_DIALOG.DIALOG_TITLE,
    en: 'Game information settings',
    ja: '対局情報設定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_DIALOG.OPENING_RULE_LABEL,
    en: 'Opening rule',
    ja: '開局規定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_DIALOG.TITLE_LABEL,
    en: 'Title',
    ja: 'タイトル',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_DIALOG.PLAYER_NAME_LABEL,
    en: 'Player name',
    ja: '対局者名',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_DIALOG.NUMBER_OF_MOVES_AT_THE_END_OF_THE_GAME_LABEL,
    en: 'Number of moves',
    ja: '終局時の手数',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_DIALOG.GAME_RESULT,
    en: 'Game result',
    ja: '結果',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_DIALOG.BLACK,
    en: 'Black {number}',
    ja: '黒{number}',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_DIALOG.WHITE,
    en: 'White {number}',
    ja: '白{number}',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_DIALOG.NOTIFY_DIALOG.DIALOG_TITLE,
    en: 'Notice',
    ja: '注意',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.GAME_INFO_DIALOG.NOTIFY_DIALOG.CONTENT,
    en: 'If you change the opening rule, the information will be deleted. Are you sure?',
    ja: '開局規定を変更すると入力したデータは削除されますが宜しいですか？',
    cn: '',
    tw: '',
    ko: '',
  },

  // SETTINGS_DIALOG
  { wid: WID.SETTINGS_DIALOG.DIALOG_TITLE,
    en: 'Settings',
    ja: '設定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SETTINGS_DIALOG.DISPLAY_SETTINGS.SUBTITLE,
    en: 'Display settings',
    ja: '表示設定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SETTINGS_DIALOG.DISPLAY_SETTINGS.COORDINATE,
    en: 'Coordinate',
    ja: '座標',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SETTINGS_DIALOG.DISPLAY_SETTINGS.NUMBER_OF_MOVE,
    en: 'Number of move',
    ja: '珠順',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SETTINGS_DIALOG.DISPLAY_SETTINGS.FORBIDDEN,
    en: 'Forbidden move mark',
    ja: '禁手マーク',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SETTINGS_DIALOG.DISPLAY_SETTINGS.NEXT_MOVE_MARK,
    en: 'Next move mark',
    ja: '次の一手マーク',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SETTINGS_DIALOG.DISPLAY_SETTINGS.LAST_MOVE_MARK,
    en: 'Last move mark',
    ja: '最終手マーク',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SETTINGS_DIALOG.GAME_INFO_SETTINGS.SUBTITLE,
    en: 'Game information',
    ja: '対局情報設定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SETTINGS_DIALOG.GAME_INFO_SETTINGS.TITLE,
    en: 'Title',
    ja: 'タイトル',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SETTINGS_DIALOG.GAME_INFO_SETTINGS.PLAYER_NAME,
    en: 'Player name',
    ja: '対局者名',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SETTINGS_DIALOG.GAME_INFO_SETTINGS.GAME_RESULT,
    en: 'Game result',
    ja: '対局結果',
    cn: '',
    tw: '',
    ko: '',
  },

  // PUZZLE_INFO_DIALOG
  { wid: WID.PUZZLE_INFO_DIALOG.DIALOG_TITLE,
    en: 'Puzzle information settings',
    ja: '詰め連珠情報設定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_INFO_DIALOG.TURN_LABEL,
    en: 'Turn',
    ja: '手番',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_INFO_DIALOG.PUZZLE_TYPE_LABEL,
    en: 'Puzzle type',
    ja: '問題の種別',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PUZZLE_INFO_DIALOG.LEVEL_LABEL,
    en: 'Level',
    ja: '難易度',
    cn: '',
    tw: '',
    ko: '',
  },

  // CONTROL_CARD
  { wid: WID.CONTROL_CARD.SOOSYRV8_SWAP_BOX.MESSAGE_DO_YOU_SWAP,
    en: 'Do you swap?',
    ja: 'スワップしますか？',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.CONTROL_CARD.SOOSYRV8_SWAP_BOX.YES_BUTTON,
    en: 'Yes (Selector)',
    ja: 'はい（選択者）',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.CONTROL_CARD.SOOSYRV8_SWAP_BOX.NO_BUTTON,
    en: 'No (Declarer)',
    ja: 'いいえ（提示者）',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.CONTROL_CARD.SOOSYRV8_FIVE_MOVE_NUMBER_BOX.MESSAGE_DECLARE_NUMBER_OF_FIFTH_MOVES,
    en: 'Declare number of fifth moves',
    ja: '題数提示',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.CONTROL_CARD.SOOSYRV8_FIVE_MOVE_NUMBER_BOX.OK_BUTTON,
    en: 'OK',
    ja: 'OK',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.CONTROL_CARD.SOOSYRV8_FIVE_MOVES_BOX.MESSAGE_IS_IT_OK,
    en: 'Is it OK?',
    ja: 'こちらの提示でよろしいですか？',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.CONTROL_CARD.SOOSYRV8_FIVE_MOVES_BOX.OK_BUTTON,
    en: 'OK',
    ja: 'OK',
    cn: '',
    tw: '',
    ko: '',
  },

  // EDIT_MODE_MENU
  { wid: WID.EDIT_MODE_MENU.PUZZLE_CONFIRM_DIALOG.TITLE,
    en: 'Notice',
    ja: '注意',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EDIT_MODE_MENU.PUZZLE_CONFIRM_DIALOG.CONTENT,
    en: 'Are you sure the move number will be deleted?',
    ja: '珠順情報は削除されますがよろしいでしょうか？',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EDIT_MODE_MENU.NORMAL_CONFIRM_DIALOG.TITLE,
    en: 'Notice',
    ja: '注意',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EDIT_MODE_MENU.NORMAL_CONFIRM_DIALOG.CONTENT,
    en: 'Are you sure all the stones will be deleted?',
    ja: '全ての石が削除されますがよろしいでしょうか？',
    cn: '',
    tw: '',
    ko: '',
  },

  // SETTINGS_MENU_ITEMS
  { wid: WID.SETTINGS_MENU_ITEMS.USER_INFORMATION,
    en: 'User information',
    ja: 'ユーザー情報',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SETTINGS_MENU_ITEMS.RENJU_BOARD,
    en: 'Renju board',
    ja: '連珠盤',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SETTINGS_MENU_ITEMS.PAYMENT,
    en: 'Payment history',
    ja: '支払い履歴',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SETTINGS_MENU_ITEMS.DONATION,
    en: 'Donation',
    ja: '寄付',
    cn: '',
    tw: '',
    ko: '',
  },

  // ACCOUNT_SETTINGS_CARD
  { wid: WID.ACCOUNT_SETTINGS_CARD.TITLE,
    en: 'User information',
    ja: 'ユーザー情報',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.AVATAR_LABEL,
    en: 'Avatar (Recomend: 200px/200px)',
    ja: 'アバター ※推奨:200px/200px',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.CHANGE_BUTTON,
    en: 'Change',
    ja: '変更',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.HEADER_LABEL,
    en: 'Header (Recomend: 1200px/200px)',
    ja: 'ヘッダー ※推奨:1200px/200px',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.USER_NAME_LABEL,
    en: 'User name',
    ja: 'ユーザー名',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.DISPLAY_NAME_LABEL,
    en: 'Display name',
    ja: '名前',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.RANK_LABEL,
    en: 'Rank',
    ja: '段/級',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.COUNTRY_LABEL,
    en: 'Country',
    ja: '国',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.CITY_LABEL,
    en: 'City',
    ja: '市',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.BIRTHDAY_LABEL,
    en: 'Birth day',
    ja: '誕生日',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.SELF_INTRODUCTION_LABEL,
    en: 'Self introduction',
    ja: '自己紹介',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.SAVE_BUTTON,
    en: 'Save',
    ja: '変更を保存',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.ERROR_MESSAGE_NAME_IS_ALREADY_BEING_USED,
    en: 'Name is already being used.',
    ja: '既に使用されています。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.SUCCESS,
    en: 'Success',
    ja: '完了',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.FAILED,
    en: 'Failed',
    ja: '失敗',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.NOTIFY_UPDATE_COMPLETE,
    en: 'Update complete',
    ja: '更新が完了しました。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.ACCOUNT_SETTINGS_CARD.NOTIFY_UPDATE_FAILED,
    en: 'Update failed',
    ja: '更新に失敗しました。',
    cn: '',
    tw: '',
    ko: '',
  },

  // RANK_ITEMS
  { wid: WID.RANK_ITEMS.DAN,
    en: '{number} Dan',
    ja: '{number} 段',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RANK_ITEMS.KYU,
    en: '{number} Kyu',
    ja: '{number} 級',
    cn: '',
    tw: '',
    ko: '',
  },

  // RENJU_BOARD_SETTINGS_CARD
  { wid: WID.RENJU_BOARD_SETTINGS_CARD.TITLE,
    en: 'Renju board settings',
    ja: '連珠盤設定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_SETTINGS_CARD.NUMBER_OF_MOVE,
    en: 'Number of move',
    ja: '珠順',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_SETTINGS_CARD.FORBIDDEN_MOVE_MARK,
    en: 'Forbidden move mark',
    ja: '禁手マーク',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_SETTINGS_CARD.NEXT_MOVE_MARK,
    en: 'Next move mark',
    ja: '次の一手マーク',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.RENJU_BOARD_SETTINGS_CARD.LAST_MOVE_MARK,
    en: 'Last move mark',
    ja: '最終手マーク',
    cn: '',
    tw: '',
    ko: '',
  },

  // USER_TAB_ITEMS
  { wid: WID.USER_TAB_ITEMS.PROFILE,
    en: 'Profile',
    ja: 'プロフィール',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.USER_TAB_ITEMS.EVENT,
    en: 'Event',
    ja: 'イベント',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.USER_TAB_ITEMS.PUZZLE,
    en: 'Puzzle',
    ja: 'パズル',
    cn: '',
    tw: '',
    ko: '',
  },

  // PROFILE_PAGE
  { wid: WID.PROFILE_PAGE.SELF_INTRODUCTION,
    en: 'Self introduction',
    ja: '自己紹介',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PROFILE_PAGE.RANK_LABEL,
    en: 'Rank',
    ja: '段/級',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PROFILE_PAGE.COUNTRY_LABEL,
    en: 'Country',
    ja: '国',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PROFILE_PAGE.CITY_LABEL,
    en: 'City',
    ja: '市',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PROFILE_PAGE.BIRTHDAY_LABEL,
    en: 'Birthday',
    ja: '誕生日',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.PROFILE_PAGE.JOINED,
    en: 'Joined {date}',
    ja: '{date} に登録',
    cn: '',
    tw: '',
    ko: '',
  },

  // EVENT_TAB
  { wid: WID.EVENT_TAB.OWNER,
    en: 'Owner',
    ja: '主催者',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_TAB.ATTEND,
    en: 'Attend',
    ja: '参加予定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.EVENT_TAB.INTEREST,
    en: 'Interest',
    ja: '興味あり',
    cn: '',
    tw: '',
    ko: '',
  },

  // LOGIN
  { wid: WID.LOGIN.BACK_BUTTON,
    en: 'Back',
    ja: '戻る',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LOGIN.TERMS_OF_SERVICE_BUTTON,
    en: 'Terms of service',
    ja: '利用規約',
    cn: '',
    tw: '',
    ko: '',
  },

  // LOGIN_CARD
  { wid: WID.LOGIN_CARD.CARD_TITLE,
    en: 'Login to Renju Portal',
    ja: 'Renju Portal へのログイン',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.LOGIN_CARD.CONTENT,
    en: 'After logging in, various services will be available.',
    ja: 'ログインすると各種サービスが利用可能となります。',
    cn: '',
    tw: '',
    ko: '',
  },

  // SIGN_UP
  { wid: WID.SIGN_UP.LOGOUT_AND_USE_BUTTON,
    en: 'Logout and use',
    ja: 'ログアウトして使用する',
    cn: '',
    tw: '',
    ko: '',
  },

  // SIGN_UP_CARD
  { wid: WID.SIGN_UP_CARD.CARD_TITLE,
    en: 'Account settings',
    ja: 'アカウント設定',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SIGN_UP_CARD.CONTENT,
    en: 'Please set "User name" and "Display name". The set contents can be changed on the settings page.',
    ja: '「ユーザー名」と「名前」を設定してください。設定した内容は設定画面にて変更可能です。',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SIGN_UP_CARD.USER_NAME_LABEL,
    en: 'User name',
    ja: 'ユーザー名 (半角英数)',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SIGN_UP_CARD.DISPLAY_NAME_LABEL,
    en: 'Display name',
    ja: '名前',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SIGN_UP_CARD.REGISTER_BUTTON,
    en: 'Register',
    ja: '登録',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.SIGN_UP_CARD.NOTIFY.MESSAGE_NAME_IS_ALREADY_BEING_USED,
    en: 'Name is already being used',
    ja: 'そのユーザー名は既に使われています。',
    cn: '',
    tw: '',
    ko: '',
  },

  // COMMENT
  { wid: WID.COMMENT.ENTER_A_COMMENT,
    en: 'Enter a comment...',
    ja: 'コメントを入力...',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.COMMENT.COMMENT_BUTTON,
    en: 'Comment',
    ja: 'コメント',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.COMMENT.DELETE_BUTTON,
    en: 'Delete',
    ja: '削除',
    cn: '',
    tw: '',
    ko: '',
  },
  { wid: WID.COMMENT.MESSAGE_NOT_ALLOWED,
    en: 'Comments are not allowed.',
    ja: 'コメントは許可されていません。',
    cn: '',
    tw: '',
    ko: '',
  },

  // PAYMENT_CARD
  {
    wid: WID.PAYMENT_CARD.CARD_TITLE,
    en: 'Payment History',
    ja: '支払い履歴',
    cn: '',
    tw: '',
    ko: '',
  },
  {
    wid: WID.PAYMENT_CARD.PAYER,
    en: 'Payer',
    ja: '購入者',
    cn: '',
    tw: '',
    ko: '',
  },

  // PAYPAL_CARD
  {
    wid: WID.PAYPAL_CARD.PAYMENT_TYPE,
    en: 'Payment type',
    ja: '支払い種別',
    cn: '',
    tw: '',
    ko: '',
  },
  {
    wid: WID.PAYPAL_CARD.AMOUNT,
    en: 'Amount',
    ja: '金額',
    cn: '',
    tw: '',
    ko: '',
  },
  {
    wid: WID.PAYPAL_CARD.GIVE_MONTHLY,
    en: 'give monthly',
    ja: '毎月払い',
    cn: '',
    tw: '',
    ko: '',
  },
  {
    wid: WID.PAYPAL_CARD.JUST_ONCE,
    en: 'just once',
    ja: '一回払い',
    cn: '',
    tw: '',
    ko: '',
  },
  {
    wid: WID.PAYPAL_CARD.OTHER,
    en: 'Other',
    ja: 'その他',
    cn: '',
    tw: '',
    ko: '',
  },

  // DONATION_SETTINGS_CARD
  {
    wid: WID.DONATION_SETTINGS_CARD.CARD_HEADER,
    en: 'Donation',
    ja: '寄付',
    cn: '',
    tw: '',
    ko: '',
  },
  {
    wid: WID.DONATION_SETTINGS_CARD.VISIBLE_DONOR,
    en: 'Visible Donor',
    ja: '寄付者としてサイト内に掲載することを許可',
    cn: '',
    tw: '',
    ko: '',
  },

  // SOUND_SETTINGS_DIALOG
  {
    wid: WID.SOUND_SETTINGS_DIALOG.ENTER,
    en: 'Enter the game room',
    ja: '入室',
    cn: '',
    tw: '',
    ko: '',
  },
  {
    wid: WID.SOUND_SETTINGS_DIALOG.PUT_PIECE,
    en: 'Put a piece',
    ja: '着手',
    cn: '',
    tw: '',
    ko: '',
  },
  {
    wid: WID.SOUND_SETTINGS_DIALOG.SWAP,
    en: 'Swap',
    ja: '交換',
    cn: '',
    tw: '',
    ko: '',
  },

  // REQUEST_PASSWORD_DIALOG
  {
    wid: WID.REQUEST_PASSWORD_DIALOG.LABEL,
    en: 'Password',
    ja: 'パスワード',
    cn: '',
    tw: '',
    ko: '',
  },
]



// WEBPACK FOOTER //
// ./src/constants/Language.js